// Source : http://prefix.cc/context
const PREFIX_REFERENCE = {
    "madsrdf": "http://www.loc.gov/mads/rdf/v1#",
    "bflc": "http://id.loc.gov/ontologies/bflc/",
    "rdf": "http://www.w3.org/1999/02/22-rdf-syntax-ns#",
    "foaf": "http://xmlns.com/foaf/0.1/",
    "rdfs": "http://www.w3.org/2000/01/rdf-schema#",
    "yago": "http://yago-knowledge.org/resource/",
    "dbo": "http://dbpedia.org/ontology/",
    "ex": "http://example.org/",
    "dbp": "http://dbpedia.org/property/",
    "dc": "http://purl.org/dc/elements/1.1/",
    "owl": "http://www.w3.org/2002/07/owl#",
    "gr": "http://purl.org/goodrelations/v1#",
    "spacerel": "http://data.ordnancesurvey.co.uk/ontology/spatialrelations/",
    "skos": "http://www.w3.org/2004/02/skos/core#",
    "geo": "http://www.opengis.net/ont/geosparql#",
    "dcat": "http://www.w3.org/ns/dcat#",
    "schema": "http://schema.org/",
    "xsd": "http://www.w3.org/2001/XMLSchema#",
    "bf": "http://id.loc.gov/ontologies/bibframe/",
    "search": "http://sindice.com/vocab/search#",
    "dct": "http://purl.org/dc/terms/",
    "qb": "http://purl.org/linked-data/cube#",
    "org": "http://www.w3.org/ns/org#",
    "sd": "http://www.w3.org/ns/sparql-service-description#",
    "dcterms": "http://purl.org/dc/terms/",
    "frbr": "http://purl.org/vocab/frbr/core#",
    "prov": "http://www.w3.org/ns/prov#",
    "stat": "http://www.w3.org/ns/posix/stat#",
    "sioc": "http://rdfs.org/sioc/ns#",
    "xtypes": "http://purl.org/xtypes/",
    "ont": "http://purl.org/net/ns/ontology-annot#",
    "dbpedia": "http://dbpedia.org/resource/",
    "commerce": "http://search.yahoo.com/searchmonkey/commerce/",
    "void": "http://rdfs.org/ns/void#",
    "vcard": "http://www.w3.org/2006/vcard/ns#",
    "onto": "http://www.ontotext.com/",
    "rss": "http://purl.org/rss/1.0/",
    "bibo": "http://purl.org/ontology/bibo/",
    "gldp": "http://www.w3.org/ns/people#",
    "dbr": "http://dbpedia.org/resource/",
    "geonames": "http://www.geonames.org/ontology#",
    "event": "http://purl.org/NET/c4dm/event.owl#",
    "fb": "http://rdf.freebase.com/ns/",
    "pto": "http://www.productontology.org/id/",
    "wd": "http://www.wikidata.org/entity/",
    "sio": "http://semanticscience.org/resource/",
    "dcmit": "http://purl.org/dc/dcmitype/",
    "oo": "http://purl.org/openorg/",
    "cc": "http://creativecommons.org/ns#",
    "md": "http://www.w3.org/ns/md#",
    "doap": "http://usefulinc.com/ns/doap#",
    "rr": "http://www.w3.org/ns/r2rml#",
    "sc": "http://purl.org/science/owl/sciencecommons/",
    "gen": "http://purl.org/gen/0.1#",
    "dbpprop": "http://dbpedia.org/property/",
    "swrc": "http://swrc.ontoware.org/ontology#",
    "content": "http://purl.org/rss/1.0/modules/content/",
    "vann": "http://purl.org/vocab/vann/",
    "prog": "http://purl.org/prog/",
    "http": "http://www.w3.org/2011/http#",
    "nie": "http://www.semanticdesktop.org/ontologies/2007/01/19/nie#",
    "ma": "http://www.w3.org/ns/ma-ont#",
    "wot": "http://xmlns.com/wot/0.1/",
    "tl": "http://purl.org/NET/c4dm/timeline.owl#",
    "obo": "http://purl.obolibrary.org/obo/",
    "akt": "http://www.aktors.org/ontology/portal#",
    "ov": "http://open.vocab.org/terms/",
    "fn": "http://www.w3.org/2005/xpath-functions#",
    "dcterm": "http://purl.org/dc/terms/",
    "cv": "http://rdfs.org/resume-rdf/",
    "aiiso": "http://purl.org/vocab/aiiso/schema#",
    "swc": "http://data.semanticweb.org/ns/swc/ontology#",
    "vs": "http://www.w3.org/2003/06/sw-vocab-status/ns#",
    "ical": "http://www.w3.org/2002/12/cal/ical#",
    "marcrel": "http://id.loc.gov/vocabulary/relators/",
    "crm": "http://www.cidoc-crm.org/cidoc-crm/",
    "earl": "http://www.w3.org/ns/earl#",
    "xhtml": "http://www.w3.org/1999/xhtml#",
    "mo": "http://purl.org/ontology/mo/",
    "dbowl": "http://ontology.cybershare.utep.edu/dbowl/relational-to-ontology-mapping-primitive.owl#",
    "rel": "http://purl.org/vocab/relationship/",
    "daia": "http://purl.org/ontology/daia/",
    "bio": "http://purl.org/vocab/bio/0.1/",
    "prop": "http://dbpedia.org/property/",
    "rdfg": "http://www.w3.org/2004/03/trix/rdfg-1/",
    "dcam": "http://purl.org/dc/dcam/",
    "ad": "http://schemas.talis.com/2005/address/schema#",
    "cs": "http://purl.org/vocab/changeset/schema#",
    "xmp": "http://ns.adobe.com/xap/1.0/",
    "dc11": "http://purl.org/dc/elements/1.1/",
    "bill": "http://www.rdfabout.com/rdf/schema/usbill/",
    "test2": "http://this.invalid/test2#",
    "dv": "http://rdf.data-vocabulary.org/#",
    "factbook": "http://wifo5-04.informatik.uni-mannheim.de/factbook/ns#",
    "xhv": "http://www.w3.org/1999/xhtml/vocab#",
    "co": "http://purl.org/ontology/co/core#",
    "musim": "http://purl.org/ontology/similarity/",
    "og": "http://ogp.me/ns#",
    "air": "http://dig.csail.mit.edu/TAMI/2007/amord/air#",
    "d2rq": "http://www.wiwiss.fu-berlin.de/suhl/bizer/D2RQ/0.1#",
    "xs": "http://www.w3.org/2001/XMLSchema#",
    "log": "http://www.w3.org/2000/10/swap/log#",
    "book": "http://purl.org/NET/book/vocab#",
    "media": "http://search.yahoo.com/searchmonkey/media/",
    "admin": "http://webns.net/mvcb/",
    "ir": "http://www.ontologydesignpatterns.org/cp/owl/informationrealization.owl#",
    "afn": "http://jena.hpl.hp.com/ARQ/function#",
    "mu": "http://mu.semte.ch/vocabularies/core/",
    "xfn": "http://gmpg.org/xfn/11#",
    "pc": "http://purl.org/procurement/public-contracts#",
    "biblio": "http://purl.org/net/biblio#",
    "ctag": "http://commontag.org/ns#",
    "tzont": "http://www.w3.org/2006/timezone#",
    "days": "http://ontologi.es/days#",
    "botany": "http://purl.org/NET/biol/botany#",
    "sism": "http://purl.oclc.org/NET/sism/0.1/",
    "xf": "http://www.w3.org/2002/xforms/",
    "reco": "http://purl.org/reco#",
    "dcq": "http://purl.org/dc/qualifiers/1.0/",
    "tag": "http://www.holygoat.co.uk/owl/redwood/0.1/tags/",
    "cal": "http://www.w3.org/2002/12/cal/ical#",
    "time": "http://www.w3.org/2006/time#",
    "cld": "http://purl.org/cld/terms/",
    "osag": "http://www.ordnancesurvey.co.uk/ontology/AdministrativeGeography/v2.0/AdministrativeGeography.rdf#",
    "dir": "http://schemas.talis.com/2005/dir/schema#",
    "rif": "http://www.w3.org/2007/rif#",
    "myspace": "http://purl.org/ontology/myspace#",
    "af": "http://purl.org/ontology/af/",
    "ome": "http://purl.org/ontomedia/core/expression#",
    "unit": "http://qudt.org/vocab/unit/",
    "sr": "http://www.openrdf.org/config/repository/sail#",
    "cmp": "http://www.ontologydesignpatterns.org/cp/owl/componency.owl#",
    "memo": "http://ontologies.smile.deri.ie/2009/02/27/memo#",
    "con": "http://www.w3.org/2000/10/swap/pim/contact#",
    "cyc": "http://sw.opencyc.org/concept/",
    "sdmx": "http://purl.org/linked-data/sdmx#",
    "jdbc": "http://d2rq.org/terms/jdbc/",
    "math": "http://www.w3.org/2000/10/swap/math#",
    "rev": "http://purl.org/stuff/rev#",
    "giving": "http://ontologi.es/giving#",
    "ok": "http://okkam.org/terms#",
    "swande": "http://purl.org/swan/1.2/discourse-elements/",
    "swanq": "http://purl.org/swan/1.2/qualifiers/",
    "dcn": "http://www.w3.org/2007/uwa/context/deliverycontext.owl#",
    "lomvoc": "http://ltsc.ieee.org/rdf/lomv1p0/vocabulary#",
    "owlim": "http://www.ontotext.com/trree/owlim#",
    "oa": "http://www.w3.org/ns/oa#",
    "gn": "http://www.geonames.org/ontology#",
    "as": "https://www.w3.org/ns/activitystreams#",
    "cfp": "http://sw.deri.org/2005/08/conf/cfp.owl#",
    "sdmxdim": "http://purl.org/linked-data/sdmx/2009/dimension#",
    "qudt": "http://qudt.org/schema/qudt/",
    "photoshop": "http://ns.adobe.com/photoshop/1.0/",
    "omn": "http://open-multinet.info/ontology/omn#",
    "wfs": "http://schemas.opengis.net/wfs/",
    "lyou": "http://purl.org/linkingyou/",
    "exif": "http://www.w3.org/2003/12/exif/ns#",
    "sdmxa": "http://purl.org/linked-data/sdmx/2009/attribute#",
    "om": "http://opendata.caceres.es/def/ontomunicipio#",
    "xsi": "http://www.w3.org/2001/XMLSchema-instance#",
    "type": "https://webiomed.ai/blog/obzor-rossiiskikh-sistem-podderzhki-priniatiia-vrachebnykh-reshenii/",
    "adms": "http://www.w3.org/ns/adms#",
    "lemon": "http://lemon-model.net/lemon#",
    "ontology": "http://dbpedia.org/ontology/",
    "dul": "http://www.ontologydesignpatterns.org/ont/dul/DUL.owl#",
    "swrl": "http://www.w3.org/2003/11/swrl#",
    "db": "http://dbpedia.org/",
    "cert": "http://www.w3.org/ns/auth/cert#",
    "swrcfe": "http://www.morelab.deusto.es/ontologies/swrcfe#",
    "isbd": "http://iflastandards.info/ns/isbd/elements/",
    "skosxl": "http://www.w3.org/2008/05/skos-xl#",
    "cnt": "http://www.w3.org/2011/content#",
    "nif": "http://persistence.uni-leipzig.org/nlp2rdf/ontologies/nif-core#",
    "swrlb": "http://www.w3.org/2003/11/swrlb#",
    "ore": "http://www.openarchives.org/ore/terms/",
    "eat": "http://www.eat.rl.ac.uk/#",
    "fabio": "http://purl.org/spar/fabio/",
    "edm": "http://www.europeana.eu/schemas/edm/",
    "nfo": "http://www.semanticdesktop.org/ontologies/2007/03/22/nfo#",
    "ac": "http://umbel.org/umbel/ac/",
    "voaf": "http://purl.org/vocommons/voaf#",
    "openlinks": "http://www.openlinksw.com/schemas/virtrdf#",
    "aat": "http://vocab.getty.edu/aat/",
    "sf": "http://www.opengis.net/ont/sf#",
    "gtfs": "http://vocab.gtfs.org/terms#",
    "prism": "http://prismstandard.org/namespaces/basic/2.0/",
    "sioct": "http://rdfs.org/sioc/types#",
    "scovo": "http://purl.org/NET/scovo#",
    "gvp": "http://vocab.getty.edu/ontology#",
    "eg": "http://www.example.org/",
    "siocserv": "http://rdfs.org/sioc/services#",
    "tgn": "http://vocab.getty.edu/tgn/",
    "geoes": "http://geo.linkeddata.es/resource/",
    "ldp": "http://www.w3.org/ns/ldp#",
    "test": "http://test2.example.com/",
    "room": "http://vocab.deri.ie/rooms#",
    "drugbank": "http://www4.wiwiss.fu-berlin.de/drugbank/resource/drugbank/",
    "ulan": "http://vocab.getty.edu/ulan/",
    "coref": "http://www.rkbexplorer.com/ontologies/coref#",
    "uniprot": "http://purl.uniprot.org/uniprot/",
    "core": "http://vivoweb.org/ontology/core#",
    "pmlj": "http://inference-web.org/2.0/pml-justification.owl#",
    "dbc": "http://dbpedia.org/resource/Category:",
    "ptr": "http://www.w3.org/2009/pointers#",
    "ssn": "http://www.w3.org/ns/ssn/",
    "lv": "http://purl.org/lobid/lv#",
    "gold": "http://purl.org/linguistics/gold/",
    "go": "http://purl.org/obo/owl/GO#",
    "acc": "http://purl.org/NET/acc#",
    "georss": "http://www.georss.org/georss/",
    "bif": "http://www.openlinksw.com/schemas/bif#",
    "dbprop": "http://dbpedia.org/property/",
    "nsogi": "http://prefix.cc/nsogi:",
    "sh": "http://www.w3.org/ns/shacl#",
    "doc": "http://www.w3.org/2000/10/swap/pim/doc#",
    "whois": "http://www.kanzaki.com/ns/whois#",
    "movie": "http://data.linkedmdb.org/resource/movie/",
    "dce": "http://purl.org/dc/elements/1.1/",
    "am": "http://vocab.deri.ie/am#",
    "space": "http://purl.org/net/schemas/space/",
    "rsa": "http://www.w3.org/ns/auth/rsa#",
    "lexinfo": "http://www.lexinfo.net/ontology/3.0/lexinfo#",
    "ceo": "https://linkeddata.cultureelerfgoed.nl/vocab/def/ceo#",
    "cerif": "http://spi-fm.uca.es/neologism/cerif#",
    "music": "http://musicontology.com/",
    "rec": "http://purl.org/ontology/rec/core#",
    "geosparql": "http://www.opengis.net/ont/geosparql#",
    "java": "http://www.w3.org/2007/uwa/context/java.owl#",
    "wdt": "http://www.wikidata.org/prop/direct/",
    "itsrdf": "http://www.w3.org/2005/11/its/rdf#",
    "ro": "http://purl.org/obo/owl/ro#",
    "akts": "http://www.aktors.org/ontology/support#",
    "cco": "http://www.ontologyrepository.com/CommonCoreOntologies/",
    "wn": "http://xmlns.com/wordnet/1.6/",
    "gndo": "http://d-nb.info/standards/elementset/gnd#",
    "sparql": "http://www.w3.org/ns/sparql#",
    "lgd": "http://linkedgeodata.org/triplify/",
    "nmo": "http://www.semanticdesktop.org/ontologies/2007/03/22/nmo#",
    "mods": "http://www.loc.gov/mods/v3#",
    "imm": "http://schemas.microsoft.com/imm/",
    "dblp": "http://dblp.uni-trier.de/rdf/schema-2015-01-26#",
    "leaks": "https://onlyfans.com/chelxie/",
    "nao": "http://www.semanticdesktop.org/ontologies/2007/08/15/nao#",
    "ti": "http://www.ontologydesignpatterns.org/cp/owl/timeinterval.owl#",
    "pat": "http://purl.org/hpi/patchr#",
    "cdm": "http://publications.europa.eu/ontology/cdm#",
    "loc": "http://www.w3.org/2007/uwa/context/location.owl#",
    "sec": "https://w3id.org/security#",
    "sider": "http://www4.wiwiss.fu-berlin.de/sider/resource/sider/",
    "acl": "http://www.w3.org/ns/auth/acl#",
    "ping": "https://namso-gen.com/",
    "httph": "http://www.w3.org/2007/ont/httph#",
    "service": "http://purl.org/ontology/service#",
    "cito": "http://purl.org/spar/cito/",
    "product": "http://purl.org/commerce/product#",
    "po": "http://purl.org/ontology/po/",
    "acm": "http://www.rkbexplorer.com/ontologies/acm#",
    "dbpediaowl": "http://dbpedia.org/owl/",
    "list": "http://www.w3.org/2000/10/swap/list#",
    "sp": "http://spinrdf.org/sp#",
    "chebi": "http://bio2rdf.org/chebi:",
    "wikidata": "http://www.wikidata.org/entity/",
    "gd": "http://rdf.data-vocabulary.org/#",
    "wn20schema": "http://www.w3.org/2006/03/wn/wn20/schema/",
    "cro": "http://rhizomik.net/ontologies/copyrightonto.owl#",
    "organism": "http://eulersharp.sourceforge.net/2003/03swap/organism#",
    "meta": "https://krr.triply.cc/krr/sameas-meta/def/",
    "wdrs": "http://www.w3.org/2007/05/powder-s#",
    "kb": "http://deductions.sf.net/ontology/knowledge_base.owl#",
    "fise": "http://fise.iks-project.eu/ontology/",
    "zoology": "http://purl.org/NET/biol/zoology#",
    "opm": "https://w3id.org/opm#",
    "xml": "http://www.w3.org/XML/1998/namespace/",
    "bd": "http://www.bigdata.com/rdf#",
    "atom": "http://www.w3.org/2005/Atom/",
    "lode": "http://linkedevents.org/ontology/",
    "ignf": "http://data.ign.fr/def/ignf#",
    "ecs": "http://rdf.ecs.soton.ac.uk/ontology/ecs#",
    "prv": "http://purl.org/net/provenance/ns#",
    "formats": "http://www.w3.org/ns/formats/",
    "umbelrc": "http://umbel.org/umbel/rc/",
    "gnd": "http://d-nb.info/gnd/",
    "up": "http://purl.uniprot.org/core/",
    "leak": "http://data.ontotext.com/resource/leak/",
    "video": "http://purl.org/ontology/video#",
    "xlink": "https://es.scribd.com/doc/79794476/05-Ejercicios-Resueltos-Caja-Negra-y-Recapitulacion/",
    "swid": "http://semanticweb.org/id/",
    "geof": "http://www.opengis.net/def/function/geosparql/",
    "sesame": "http://www.openrdf.org/schema/sesame#",
    "olia": "http://purl.org/olia/olia.owl#",
    "spin": "http://spinrdf.org/spin#",
    "web": "http://www.w3.org/2007/uwa/context/web.owl#",
    "ndl": "http://schemas.ogf.org/nml/2013/05/base#",
    "abc": "http://www.metadata.net/harmony/ABCSchemaV5Commented.rdf#",
    "ya": "http://blogs.yandex.ru/schema/foaf/",
    "mf": "http://www.w3.org/2001/sw/DataAccess/tests/test-manifest#",
    "irw": "http://www.ontologydesignpatterns.org/ont/web/irw.owl#",
    "nco": "http://www.semanticdesktop.org/ontologies/2007/03/22/nco#",
    "ms": "http://purl.org/obo/owl/MS#",
    "daml": "http://www.daml.org/2001/03/daml+oil#",
    "pr": "http://purl.org/ontology/prv/core#",
    "example": "http://www.example.org/rdf#",
    "pext": "http://www.ontotext.com/proton/protonext#",
    "site": "http://ns.ontowiki.net/SysOnt/Site/",
    "penn": "http://purl.org/olia/penn.owl#",
    "resist": "http://www.rkbexplorer.com/ontologies/resist#",
    "rdfsharp": "https://rdfsharp.codeplex.com/",
    "hg": "http://rdf.histograph.io/",
    "bp": "http://www.biopax.org/release/biopax-level3.owl#",
    "protege": "http://protege.stanford.edu/system#",
    "sit": "http://www.ontologydesignpatterns.org/cp/owl/situation.owl#",
    "scot": "http://rdfs.org/scot/ns#",
    "wo": "http://purl.org/ontology/wo/",
    "postcode": "http://data.ordnancesurvey.co.uk/id/postcodeunit/",
    "cpa": "http://www.ontologydesignpatterns.org/schemas/cpannotationschema.owl#",
    "link": "http://www.w3.org/2007/ont/link#",
    "cgov": "http://reference.data.gov.uk/def/central-government/",
    "sdo": "https://schema.org/",
    "smf": "http://topbraid.org/sparqlmotionfunctions#",
    "admingeo": "http://data.ordnancesurvey.co.uk/ontology/admingeo/",
    "fresnel": "http://www.w3.org/2004/09/fresnel#",
    "pmt": "http://tipsy.googlecode.com/svn/trunk/vocab/pmt#",
    "biol": "http://purl.org/NET/biol/ns#",
    "omt": "http://purl.org/ontomedia/ext/common/trait#",
    "biocore": "http://bio2rdf.org/core#",
    "user": "http://schemas.talis.com/2005/user/schema#",
    "label": "http://purl.org/net/vocab/2004/03/label#",
    "hydra": "http://www.w3.org/ns/hydra/core#",
    "cidoc": "http://www.cidoc-crm.org/cidoc-crm/",
    "myspo": "http://purl.org/ontology/myspace#",
    "xkos": "http://rdf-vocabulary.ddialliance.org/xkos#",
    "granatum": "http://chem.deri.ie/granatum/",
    "ontolex": "http://www.w3.org/ns/lemon/ontolex#",
    "nt": "http://ns.inria.fr/nicetag/2010/09/09/voc#",
    "food": "http://purl.org/foodontology#",
    "umbel": "http://umbel.org/umbel#",
    "politico": "http://www.rdfabout.com/rdf/schema/politico/",
    "omb": "http://purl.org/ontomedia/ext/common/being#",
    "pim": "http://www.w3.org/ns/pim/space#",
    "pav": "http://purl.org/pav/",
    "dctype": "http://purl.org/dc/dcmitype/",
    "dbnary": "http://kaiko.getalp.org/dbnary#",
    "disco": "http://rdf-vocabulary.ddialliance.org/discovery#",
    "wgs": "http://www.w3.org/2003/01/geo/wgs84_pos#",
    "acco": "http://purl.org/acco/ns#",
    "mit": "http://purl.org/ontology/mo/mit#",
    "climb": "http://climb.dataincubator.org/vocabs/climb/",
    "eu": "http://eulersharp.sourceforge.net/2003/03swap/log-rules#",
    "inno": "http://purl.org/innovation/ns#",
    "sim": "http://www.w3id.org/simulation/ontology/",
    "purl": "http://www.purl.org/",
    "rnews": "http://iptc.org/std/rNews/2011-10-07#",
    "st": "http://ns.inria.fr/sparql-template/",
    "bag": "https://bag2.basisregistraties.overheid.nl/bag/def/",
    "ddc": "http://purl.org/NET/decimalised#",
    "ass": "http://uptheasset.org/ontology#",
    "agg": "http://purl.org/twc/health/vocab/aggregate/",
    "wiki": "http://en.wikipedia.org/wiki/",
    "wgs84": "http://www.w3.org/2003/01/geo/wgs84_pos#",
    "oc": "http://opencoinage.org/rdf/",
    "fec": "http://www.rdfabout.com/rdf/schema/usfec/",
    "npg": "http://ns.nature.com/terms/",
    "gsp": "http://www.opengis.net/ont/geosparql#",
    "lime": "http://www.w3.org/ns/lemon/lime#",
    "lfn": "http://www.dotnetrdf.org/leviathan#",
    "oauth": "http://demiblog.org/vocab/oauth#",
    "meteo": "http://purl.org/ns/meteo#",
    "gso": "http://www.w3.org/2006/gen/ont#",
    "sdl": "http://purl.org/vocab/riro/sdl#",
    "bibtex": "http://purl.org/net/nknouf/ns/bibtex#",
    "lx": "http://purl.org/NET/lx#",
    "iot": "http://iotschema.org/",
    "spl": "http://spinrdf.org/spl#",
    "conv": "http://purl.org/twc/vocab/conversion/",
    "overheid": "http://standaarden.overheid.nl/owms/",
    "opensearch": "http://a9.com/-/spec/opensearch/1.1/",
    "doac": "http://ramonantonio.net/doac/0.1/#",
    "wv": "http://vocab.org/waiver/terms/",
    "ocd": "http://dati.camera.it/ocd/",
    "rdau": "http://rdaregistry.info/Elements/u/",
    "taxo": "http://purl.org/rss/1.0/modules/taxonomy/",
    "compass": "http://purl.org/net/compass#",
    "gpt": "http://purl.org/vocab/riro/gpt#",
    "contact": "http://www.w3.org/2000/10/swap/pim/contact#",
    "prj": "http://purl.org/stuff/project/",
    "omc": "http://purl.org/ontomedia/ext/common/bestiary#",
    "atomix": "http://buzzword.org.uk/rdf/atomix#",
    "fed": "http://www.openrdf.org/config/sail/federation#",
    "api": "http://purl.org/linked-data/api/vocab#",
    "powder": "http://www.w3.org/2007/05/powder#",
    "bio2rdf": "http://bio2rdf.org/",
    "exterms": "http://www.example.org/terms/",
    "custom": "http://www.openrdf.org/config/sail/custom#",
    "rdrel": "http://rdvocab.info/RDARelationshipsWEMI/",
    "ngeo": "http://geovocab.org/geometry#",
    "ps": "https://w3id.org/payswarm#",
    "interval": "http://reference.data.gov.uk/def/intervals/",
    "cordis": "http://cordis.europa.eu/projects/",
    "tmo": "http://www.semanticdesktop.org/ontologies/2008/05/20/tmo#",
    "rep": "http://www.openrdf.org/config/repository#",
    "es": "http://eulersharp.sourceforge.net/2003/03swap/log-rules#",
    "seas": "https://w3id.org/seas/",
    "sco": "http://purl.org/ontology/sco#",
    "efo": "http://www.ebi.ac.uk/efo/",
    "game": "http://data.totl.net/game/",
    "airport": "http://www.daml.org/2001/10/html/airport-ont#",
    "xro": "http://purl.org/xro/ns#",
    "audio": "http://purl.org/media/audio#",
    "xen": "http://buzzword.org.uk/rdf/xen#",
    "lang": "http://ontologi.es/lang/core#",
    "rei": "http://www.w3.org/2004/06/rei#",
    "profiling": "http://ontologi.es/profiling#",
    "rdac": "http://rdaregistry.info/Elements/c/",
    "isothes": "http://purl.org/iso25964/skos-thes#",
    "soft": "http://www.w3.org/2007/uwa/context/software.owl#",
    "code": "http://telegraphis.net/ontology/measurement/code#",
    "ref": "http://purl.org/vocab/relationship/",
    "ire": "http://www.ontologydesignpatterns.org/cpont/ire.owl#",
    "lom": "http://ltsc.ieee.org/rdf/lomv1p0/lom#",
    "greg": "http://kasei.us/about/foaf.xrdf#",
    "edam": "http://edamontology.org/",
    "awol": "http://bblfish.net/work/atom-owl/2006-06-06/#",
    "string": "http://www.w3.org/2000/10/swap/string#",
    "courseware": "http://courseware.rkbexplorer.com/ontologies/courseware#",
    "pgterms": "http://www.gutenberg.org/2009/pgterms/",
    "phil": "http://philosurfical.open.ac.uk/ontology/philosurfical.owl#",
    "doclist": "http://www.junkwork.net/xml/DocumentList#",
    "frir": "http://purl.org/twc/ontology/frir.owl#",
    "library": "http://purl.org/library/",
    "uco": "http://purl.org/uco/ns#",
    "sede": "http://eventography.org/sede/0.1/",
    "swp": "http://www.w3.org/2004/03/trix/swp-2/",
    "usgov": "http://www.rdfabout.com/rdf/schema/usgovt/",
    "omp": "http://purl.org/ontomedia/ext/common/profession#",
    "xhe": "http://buzzword.org.uk/rdf/xhtml-elements#",
    "tdb": "http://jena.hpl.hp.com/2008/tdb#",
    "sport": "http://www.bbc.co.uk/ontologies/sport/",
    "cycann": "http://sw.cyc.com/CycAnnotations_v1#",
    "spc": "http://purl.org/ontomedia/core/space#",
    "omm": "http://purl.org/ontomedia/core/media#",
    "wordnet": "http://wordnet-rdf.princeton.edu/ontology#",
    "name": "http://example.org/name#",
    "conversion": "http://purl.org/twc/vocab/conversion/",
    "rov": "http://www.w3.org/ns/regorg#",
    "dailymed": "http://www4.wiwiss.fu-berlin.de/dailymed/resource/dailymed/",
    "money": "http://purl.org/net/rdf-money/",
    "res": "http://dbpedia.org/resource/",
    "push": "http://www.w3.org/2007/uwa/context/push.owl#",
    "hlisting": "http://sindice.com/hlisting/0.1/",
    "cube": "https://cube.link/",
    "affy": "http://www.affymetrix.com/community/publications/affymetrix/tmsplice#",
    "lfm": "http://purl.org/ontology/last-fm/",
    "hard": "http://www.w3.org/2007/uwa/context/hardware.owl#",
    "worldbank": "http://worldbank.270a.info/dataset/",
    "rail": "http://ontologi.es/rail/vocab#",
    "crypto": "http://www.w3.org/2000/10/swap/crypto#",
    "nrl": "http://www.semanticdesktop.org/ontologies/2007/08/15/nrl#",
    "chord": "http://purl.org/ontology/chord/",
    "ero": "http://purl.obolibrary.org/obo/",
    "vivo": "http://vivoweb.org/ontology/core#",
    "os": "http://www.w3.org/2000/10/swap/os#",
    "blt": "http://www.bl.uk/schemas/bibliographic/blterms#",
    "tio": "http://purl.org/tio/ns#",
    "xl": "http://langegger.at/xlwrap/vocab#",
    "rdfa": "http://www.w3.org/ns/rdfa#",
    "so": "http://purl.org/ontology/symbolic-music/",
    "ub": "http://www.lehigh.edu/~zhp2/2004/0401/univ-bench.owl#",
    "tags": "http://www.holygoat.co.uk/owl/redwood/0.1/tags/",
    "faldo": "http://biohackathon.org/resource/faldo#",
    "vote": "http://www.rdfabout.com/rdf/schema/vote/",
    "dady": "http://purl.org/NET/dady#",
    "sv": "http://schemas.talis.com/2005/service/schema#",
    "rdagr1": "http://rdvocab.info/Elements/",
    "lgdo": "http://linkedgeodata.org/ontology/",
    "gob": "http://purl.org/ontology/last-fm/",
    "scv": "http://purl.org/NET/scovo#",
    "obj": "http://www.openrdf.org/rdf/2009/object#",
    "sysont": "http://ns.ontowiki.net/SysOnt/",
    "biopax": "http://www.biopax.org/release/biopax-level3.owl#",
    "pbo": "http://purl.org/ontology/pbo/core#",
    "mysql": "http://web-semantics.org/ns/mysql/",
    "swivt": "http://semantic-mediawiki.org/swivt/1.0#",
    "opo": "http://online-presence.net/opo/ns#",
    "icaltzd": "http://www.w3.org/2002/12/cal/icaltzd#",
    "resource": "http://purl.org/vocab/resourcelist/schema#",
    "like": "http://ontologi.es/like#",
    "swh": "http://plugin.org.uk/swh-plugins/",
    "role": "https://w3id.org/role/",
    "oat": "http://openlinksw.com/schemas/oat/",
    "net": "http://www.w3.org/2007/uwa/context/network.owl#",
    "p3p": "http://www.w3.org/2002/01/p3prdfv1#",
    "ui": "http://www.w3.org/ns/ui#",
    "person": "http://www.w3.org/ns/person#",
    "aifb": "http://www.aifb.kit.edu/id/",
    "sail": "http://www.openrdf.org/config/sail#",
    "ct": "http://data.linkedct.org/resource/linkedct/",
    "lu": "http://www.ontologydesignpatterns.org/ont/framenet/abox/lu/",
    "muto": "http://purl.org/muto/core#",
    "resex": "http://resex.rkbexplorer.com/ontologies/resex#",
    "bib": "http://zeitkunst.org/bibtex/0.1/bibtex.owl#",
    "common": "http://www.w3.org/2007/uwa/context/common.owl#",
    "iswc": "http://annotation.semanticweb.org/2004/iswc#",
    "locn": "http://www.w3.org/ns/locn#",
    "moat": "http://moat-project.org/ns#",
    "ist": "http://purl.org/ontology/is/types/",
    "puc": "http://purl.org/NET/puc#",
    "pom": "http://maven.apache.org/POM/4.0.0#",
    "act": "http://www.w3.org/2007/rif-builtin-action#",
    "swanco": "http://purl.org/swan/1.2/swan-commons/",
    "cogs": "http://vocab.deri.ie/cogs#",
    "ao": "http://purl.org/ontology/ao/core#",
    "vsr": "http://purl.org/twc/vocab/vsr#",
    "states": "http://www.w3.org/2005/07/aaa#",
    "viaf": "http://viaf.org/viaf/",
    "meetup": "http://www.lotico.com/meetup/",
    "pmlr": "http://inference-web.org/2.0/pml-relation.owl#",
    "lotico": "http://www.lotico.com/resource/",
    "ttl": "http://www.w3.org/2008/turtle#",
    "ddl": "http://purl.org/vocab/riro/ddl#",
    "lifecycle": "http://purl.org/vocab/lifecycle/schema#",
    "cpm": "http://catalogus-professorum.org/cpm/2/",
    "freebase": "http://rdf.freebase.com/ns/",
    "coin": "http://purl.org/court/def/2009/coin#",
    "irrl": "http://www.ontologydesignpatterns.org/cp/owl/informationobjectsandrepresentationlanguages.owl#",
    "play": "http://uriplay.org/spec/ontology/#",
    "xforms": "http://www.w3.org/2002/xforms/",
    "dcmitype": "http://purl.org/dc/dcmitype/",
    "gml": "http://www.opengis.net/ont/gml#",
    "lastfm": "http://purl.org/ontology/last-fm/",
    "swandr": "http://purl.org/swan/1.2/discourse-relationships/",
    "pmlp": "http://inference-web.org/2.0/pml-provenance.owl#",
    "anca": "http://users.utcluj.ro/~raluca/rdf_ontologies_ralu/ralu_modified_ontology_pizzas2_0#",
    "conserv": "http://conserv.deri.ie/ontology#",
    "eco": "http://www.ebusiness-unibw.org/ontologies/eclass/5.1.4/#",
    "com": "http://purl.org/commerce#",
    "dwc": "http://rs.tdwg.org/dwc/terms/",
    "nexif": "http://www.semanticdesktop.org/ontologies/2007/05/10/nexif#",
    "bibframe": "http://bibframe.org/vocab/",
    "kwijibo": "http://kwijibo.talis.com/",
    "dnr": "http://www.dotnetrdf.org/configuration#",
    "swanqs": "http://purl.org/swan/1.2/qualifiers/",
    "wordmap": "http://purl.org/net/ns/wordmap#",
    "iso": "http://purl.org/iso25964/skos-thes#",
    "lt": "http://diplomski.nelakolundzija.org/LTontology.rdf#",
    "payment": "http://reference.data.gov.uk/def/payment#",
    "sml": "http://topbraid.org/sparqlmotionlib#",
    "hcterms": "http://purl.org/uF/hCard/terms/",
    "prissma": "http://ns.inria.fr/prissma/v1#",
    "ludo": "http://ns.inria.fr/ludo/v1#",
    "wdr": "http://www.w3.org/2007/05/powder#",
    "ne": "http://umbel.org/umbel/ne/",
    "cheminf": "http://www.semanticweb.org/ontologies/cheminf.owl#",
    "copyright": "http://rhizomik.net/ontologies/copyrightonto.owl#",
    "nid3": "http://www.semanticdesktop.org/ontologies/2007/05/10/nid3#",
    "pimo": "http://www.semanticdesktop.org/ontologies/2007/11/01/pimo#",
    "pobo": "http://purl.obolibrary.org/obo/",
    "phss": "http://ns.poundhill.com/phss/1.0/",
    "smiley": "http://www.smileyontology.com/ns#",
    "mime": "https://www.iana.org/assignments/media-types/",
    "isq": "http://purl.org/ontology/is/quality/",
    "muo": "http://purl.oclc.org/NET/muo/muo#",
    "won": "https://w3id.org/won/core#",
    "wnschema": "http://www.cogsci.princeton.edu/~wn/schema/",
    "txn": "http://lod.taxonconcept.org/ontology/txn.owl#",
    "yoda": "http://purl.org/NET/yoda#",
    "sm": "http://topbraid.org/sparqlmotion#",
    "dummy": "http://hello.com/",
    "apivc": "http://purl.org/linked-data/api/vocab#",
    "places": "http://purl.org/ontology/places#",
    "human": "http://eulersharp.sourceforge.net/2003/03swap/human#",
    "is": "http://purl.org/ontology/is/core#",
    "prot": "http://www.proteinontology.info/po.owl#",
    "coo": "http://purl.org/coo/ns#",
    "soc": "http://purl.org/net/hdlipcores/ontology/soc#",
    "arch": "http://purl.org/archival/vocab/arch#",
    "asn": "http://purl.org/ASN/schema/core/",
    "posh": "http://poshrdf.org/ns/posh/",
    "dbkwik": "http://dbkwik.webdatacommons.org/",
    "grddl": "http://www.w3.org/2003/g/data-view#",
    "wikipedia": "http://wikipedia.no/rdf/",
    "dcm": "http://purl.org/dc/dcmitype/",
    "ezcontext": "http://ontologies.ezweb.morfeo-project.org/ezcontext/ns#",
    "isi": "http://purl.org/ontology/is/inst/",
    "ic": "http://imi.go.jp/ns/core/rdf#",
    "osoc": "http://web-semantics.org/ns/opensocial#",
    "mei": "http://www.music-encoding.org/ns/mei/",
    "dgtwc": "http://data-gov.tw.rpi.edu/2009/data-gov-twc.rdf#",
    "pdo": "http://ontologies.smile.deri.ie/pdo#",
    "evset": "http://dsnotify.org/vocab/eventset/0.1/",
    "rulz": "http://purl.org/NET/rulz#",
    "datafaqs": "http://purl.org/twc/vocab/datafaqs#",
    "ibis": "http://purl.org/ibis#",
    "plink": "http://buzzword.org.uk/rdf/personal-link-types#",
    "vitro": "http://vitro.mannlib.cornell.edu/ns/vitro/public#",
    "lex": "http://purl.org/lex#",
    "ean": "http://openean.kaufkauf.net/id/",
    "httpvoc": "http://www.w3.org/2006/http#",
    "lingvoj": "http://www.lingvoj.org/ontology#",
    "eli": "http://data.europa.eu/eli/ontology#",
    "enc": "http://www.w3.org/2001/04/xmlenc#",
    "olo": "http://purl.org/ontology/olo/core#",
    "psych": "http://purl.org/vocab/psychometric-profile/",
    "arpfo": "http://vocab.ouls.ox.ac.uk/projectfunding#",
    "eztag": "http://ontologies.ezweb.morfeo-project.org/eztag/ns#",
    "session": "http://redfoot.net/2005/session#",
    "hospital": "http://www.agfa.com/w3c/2009/hospital#",
    "rdaa": "http://rdaregistry.info/Elements/a/",
    "nsa": "http://multimedialab.elis.ugent.be/organon/ontologies/ninsuna#",
    "bsbm": "http://www4.wiwiss.fu-berlin.de/bizer/bsbm/v01/vocabulary/",
    "oad": "http://lod.xdams.org/reload/oad/",
    "sioca": "http://rdfs.org/sioc/actions#",
    "ldap": "http://purl.org/net/ldap/",
    "aos": "http://rdf.muninn-project.org/ontologies/appearances#",
    "rooms": "http://vocab.deri.ie/rooms#",
    "lvont": "http://lexvo.org/ontology#",
    "lp": "http://launchpad.net/rdf/launchpad#",
    "urn": "http://fliqz.com/",
    "trackback": "http://madskills.com/public/xml/rss/module/trackback/",
    "h5": "http://buzzword.org.uk/rdf/h5#",
    "bte": "http://purl.org/twc/vocab/between-the-edges/",
    "address": "http://schemas.talis.com/2005/address/schema#",
    "cex": "http://purl.org/weso/computex/ontology#",
    "uri": "http://purl.org/NET/uri#",
    "drug": "http://www.agfa.com/w3c/2009/drugTherapy#",
    "geospecies": "http://rdf.geospecies.org/ont/geospecies#",
    "pro": "http://purl.org/hpi/patchr#",
    "pml": "http://provenanceweb.org/ns/pml#",
    "omv": "http://omv.ontoware.org/2005/05/ontology#",
    "xds": "http://www.w3.org/2001/XMLSchema#",
    "tripfs": "http://purl.org/tripfs/2010/02#",
    "cpv": "http://purl.org/weso/cpv/",
    "okkam": "http://models.okkam.org/ENS-core-vocabulary#",
    "deo": "http://purl.org/spar/deo/",
    "arg": "http://rdfs.org/sioc/argument#",
    "vso": "http://purl.org/vso/ns#",
    "ncal": "http://www.semanticdesktop.org/ontologies/2007/04/02/ncal#",
    "dbpp": "http://dbpedia.org/property/",
    "c4n": "http://vocab.deri.ie/c4n#",
    "kontakt": "http://richard.cyganiak.de/",
    "dco": "http://info.deepcarbon.net/schema#",
    "card": "http://www.ashutosh.com/test/",
    "qdoslf": "http://foaf.qdos.com/lastfm/schema/",
    "wlp": "http://weblab-project.org/core/model/property/processing/",
    "zem": "http://s.zemanta.com/ns#",
    "fab": "http://purl.org/fab/ns#",
    "ann": "http://www.w3.org/2000/10/annotation-ns#",
    "tarot": "http://data.totl.net/tarot/card/",
    "b2bo": "http://purl.org/b2bo#",
    "agents": "http://eulersharp.sourceforge.net/2003/03swap/agent#",
    "wai": "http://purl.org/wai#",
    "teach": "http://linkedscience.org/teach/ns#",
    "oslc": "http://open-services.net/ns/core#",
    "timeline": "http://purl.org/NET/c4dm/timeline.owl#",
    "xhtmlvocab": "http://www.w3.org/1999/xhtml/vocab/",
    "opus": "http://lsdis.cs.uga.edu/projects/semdis/opus#",
    "webtlab": "http://webtlab.it.uc3m.es/",
    "eclap": "http://www.eclap.eu/schema/eclap/",
    "wairole": "http://www.w3.org/2005/01/wai-rdf/GUIRoleTaxonomy#",
    "bing": "http://bing.com/schema/media/",
    "swanpav": "http://purl.org/swan/1.2/pav/",
    "dt": "http://dbpedia.org/datatype/",
    "calli": "http://callimachusproject.org/rdf/2009/framework#",
    "cmo": "http://purl.org/twc/ontologies/cmo.owl#",
    "bbc": "http://www.bbc.co.uk/ontologies/news/",
    "geographis": "http://telegraphis.net/ontology/geography/geography#",
    "muni": "http://vocab.linkeddata.es/urbanismo-infraestructuras/territorio#",
    "aapi": "http://rdf.alchemyapi.com/rdf/v1/s/aapi-schema#",
    "status": "http://www.w3.org/2003/06/sw-vocab-status/ns#",
    "sl": "http://www.semanlink.net/2001/00/semanlink-schema#",
    "dso": "http://purl.org/ontology/dso#",
    "agetec": "http://www.agetec.org/",
    "eprints": "http://eprints.org/ontology/",
    "prvtypes": "http://purl.org/net/provenance/types#",
    "voag": "http://voag.linkedmodel.org/schema/voag#",
    "osgb": "http://data.ordnancesurvey.co.uk/id/",
    "pos": "http://www.w3.org/2003/01/geo/wgs84_pos#",
    "derecho": "http://purl.org/derecho#",
    "premis": "http://www.loc.gov/premis/rdf/v3/",
    "zbwext": "http://zbw.eu/namespaces/zbw-extensions/",
    "mygrid": "http://www.mygrid.org.uk/ontology#",
    "fea": "http://vocab.data.gov/def/fea#",
    "np": "http://www.nanopub.org/nschema#",
    "languages": "http://eulersharp.sourceforge.net/2003/03swap/languages#",
    "bookmark": "http://www.w3.org/2002/01/bookmark#",
    "lark1": "http://users.utcluj.ro/~raluca/ontology/Ontology1279614123500.owl#",
    "br": "http://vocab.deri.ie/br#",
    "care": "http://eulersharp.sourceforge.net/2003/03swap/care#",
    "dive": "http://scubadive.networld.to/dive.rdf#",
    "stanford": "http://purl.org/olia/stanford.owl#",
    "frbre": "http://purl.org/vocab/frbr/extended#",
    "cos": "http://www.inria.fr/acacia/corese#",
    "dita": "http://purl.org/dita/ns#",
    "ogp": "http://ogp.me/ns#",
    "algo": "http://securitytoolbox.appspot.com/securityAlgorithms#",
    "mm": "http://linkedmultimedia.org/sparql-mm/ns/2.0.0/function#",
    "marl": "http://www.gsi.dit.upm.es/ontologies/marl/ns#",
    "bmo": "http://collection.britishmuseum.org/id/ontology/",
    "odrl": "http://www.w3.org/ns/odrl/2/",
    "pmlt": "http://inference-web.org/2.0/pml-trust.owl#",
    "ospost": "http://data.ordnancesurvey.co.uk/ontology/postcode/",
    "opwn": "http://www.ontologyportal.org/WordNet.owl#",
    "geodata": "http://sws.geonames.org/",
    "gv": "http://rdf.data-vocabulary.org/#",
    "wisski": "http://wiss-ki.eu/",
    "toby": "http://tobyinkster.co.uk/#",
    "rda": "http://www.rdaregistry.info/",
    "req": "http://purl.org/req/",
    "aneo": "http://akonadi-project.org/ontologies/aneo#",
    "sawsdl": "http://www.w3.org/ns/sawsdl#",
    "aair": "http://xmlns.notu.be/aair#",
    "bne": "http://datos.bne.es/resource/",
    "imreg": "http://www.w3.org/2004/02/image-regions#",
    "rdo": "http://purl.org/rdo/ns#",
    "tr": "http://www.thomsonreuters.com/",
    "wp": "http://vocabularies.wikipathways.org/wp#",
    "wi": "http://purl.org/ontology/wi/core#",
    "span": "http://www.ifomis.org/bfo/1.1/span#",
    "ncbitaxon": "http://purl.org/obo/owl/NCBITaxon#",
    "nuts": "http://dd.eionet.europa.eu/vocabulary/common/nuts/",
    "bsb": "http://opacplus.bsb-muenchen.de/title/",
    "remus": "http://www.semanticweb.org/ontologies/2010/6/Ontology1279614123500.owl#",
    "tcga": "http://purl.org/tcga/core#",
    "ppo": "http://vocab.deri.ie/ppo#",
    "osn": "http://spatial.ucd.ie/lod/osn/",
    "xesam": "http://freedesktop.org/standards/xesam/1.0/core#",
    "dnb": "http://d-nb.info/gnd/",
    "r2r": "http://www4.wiwiss.fu-berlin.de/bizer/r2r/",
    "nndsr": "http://semanticdiet.com/schema/usda/nndsr/",
    "sem": "http://semanticweb.cs.vu.nl/2009/11/sem/",
    "provenir": "http://knoesis.wright.edu/provenir/provenir.owl#",
    "life": "http://life.deri.ie/schema/",
    "odp": "http://ontologydesignpatterns.org/",
    "city": "http://datos.localidata.com/def/City#",
    "pay": "http://reference.data.gov.uk/def/payment#",
    "san": "http://www.irit.fr/recherches/MELODI/ontologies/SAN#",
    "dcr": "http://www.isocat.org/ns/dcr.rdf#",
    "spatial": "http://geovocab.org/spatial#",
    "hemogram": "http://www.agfa.com/w3c/2009/hemogram#",
    "visit": "http://purl.org/net/vocab/2004/07/visit#",
    "decl": "http://www.linkedmodel.org/1.0/schema/decl#",
    "fd": "http://foodable.co/ns/",
    "linkedct": "http://data.linkedct.org/vocab/",
    "rdam": "http://rdaregistry.info/Elements/m/",
    "wao": "http://webtlab.it.uc3m.es/2010/10/WebAppsOntology#",
    "oboe": "http://ecoinformatics.org/oboe/oboe.1.0/oboe-core.owl#",
    "prefix": "http://prefix.cc/",
    "quak": "http://dev.w3.org/cvsweb/2000/quacken/vocab#",
    "dsp": "http://purl.org/metainfo/terms/dsp#",
    "out": "http://ontologies.hypios.com/out#",
    "xfnv": "http://vocab.sindice.com/xfn#",
    "swanci": "http://purl.org/swan/1.2/citations/",
    "article": "http://ogp.me/ns/article#",
    "uni": "http://purl.org/weso/uni/uni.html#",
    "vra": "http://purl.org/vra/",
    "fls": "http://lukasblaho.sk/football_league_schema#",
    "geom": "http://data.ign.fr/def/geometrie#",
    "qa": "http://www.mit.jyu.fi/ai/TRUST_Ontologies/QA.owl#",
    "elog": "http://eulersharp.sourceforge.net/2003/03swap/log-rules#",
    "gridworks": "http://purl.org/net/opmv/types/gridworks#",
    "organiz": "http://eulersharp.sourceforge.net/2003/03swap/organization#",
    "fowl": "http://www.w3.org/TR/2003/PR-owl-guide-20031209/food#",
    "units": "http://eulersharp.sourceforge.net/2003/03swap/units#",
    "scsv": "http://purl.org/NET/schema-org-csv#",
    "sindice": "http://vocab.sindice.net/",
    "prf": "http://www.openmobilealliance.org/tech/profiles/UAPROF/ccppschema-20021212#",
    "orca": "http://geni-orca.renci.org/owl/topology.owl#",
    "fbgeo": "http://rdf.freebase.com/ns/location/geocode/",
    "esd": "http://def.esd.org.uk/",
    "c4o": "http://purl.org/spar/c4o/",
    "xsl": "http://www.w3.org/1999/XSL/Transform#",
    "sig": "http://purl.org/signature#",
    "emotion": "http://ns.inria.fr/emoca#",
    "ple": "http://pleiades.stoa.org/places/",
    "kdo": "http://kdo.render-project.eu/kdo#",
    "dayta": "http://dayta.me/resource#",
    "linkedmdb": "http://data.linkedmdb.org/sparql/",
    "iao": "http://purl.obolibrary.org/obo/iao.owl#",
    "metalex": "http://www.metalex.eu/schema/1.0#",
    "ccom": "http://purl.org/ontology/cco/mappings#",
    "skip": "http://skipforward.net/skipforward/resource/",
    "rlog": "http://persistence.uni-leipzig.org/nlp2rdf/ontologies/rlog#",
    "igeo": "http://rdf.insee.fr/def/geo#",
    "gc": "http://www.oegov.org/core/owl/gc#",
    "ens": "http://models.okkam.org/ENS-core-vocabulary.owl#",
    "reve": "http://data.eurecom.fr/ontology/reve#",
    "vaem": "http://www.linkedmodel.org/schema/vaem#",
    "comm": "http://vocab.resc.info/communication#",
    "theatre": "http://purl.org/theatre#",
    "sql": "http://ns.inria.fr/ast/sql#",
    "dis": "http://stanbol.apache.org/ontology/disambiguation/disambiguation#",
    "dbpo": "http://dbpedia.org/ontology/",
    "countries": "http://eulersharp.sourceforge.net/2003/03swap/countries#",
    "evopat": "http://ns.aksw.org/Evolution/",
    "un": "http://www.w3.org/2007/ont/unit#",
    "prvr": "http://purl.org/ontology/prv/rules#",
    "cao": "http://purl.org/makolab/caont/",
    "wbc": "http://worldbank.270a.info/classification/",
    "commons": "http://commons.psi.enakting.org/def/",
    "lr": "http://linkedrecipes.org/schema/",
    "hp": "http://purl.org/voc/hp/",
    "wbp": "http://worldbank.270a.info/property/",
    "open": "http://open.vocab.org/terms/",
    "opmv": "http://purl.org/net/opmv/ns#",
    "events": "http://eulersharp.sourceforge.net/2003/03swap/event#",
    "bioskos": "http://eulersharp.sourceforge.net/2003/03swap/bioSKOSSchemes#",
    "semtweet": "http://semantictweet.com/",
    "arecipe": "http://purl.org/amicroformat/arecipe/",
    "orges": "http://datos.gob.es/def/sector-publico/organizacion#",
    "xch": "http://oanda2rdf.appspot.com/xch/",
    "agent": "http://eulersharp.sourceforge.net/2003/03swap/agent#",
    "recipe": "http://linkedrecipes.org/schema/",
    "gelo": "http://krauthammerlab.med.yale.edu/ontologies/gelo#",
    "transit": "http://vocab.org/transit/terms/",
    "jita": "http://aims.fao.org/aos/jita/",
    "bfo": "http://purl.obolibrary.org/obo/",
    "agrelon": "http://d-nb.info/standards/elementset/agrelon#",
    "taxon": "http://purl.org/biodiversity/taxon/",
    "aims": "http://aims.fao.org/aos/common/",
    "enhancer": "http://stanbol.apache.org/ontology/enhancer/enhancer#",
    "oper": "http://sweet.jpl.nasa.gov/2.0/mathOperation.owl#",
    "tmpl": "http://purl.org/restdesc/http-template#",
    "re": "http://www.w3.org/2000/10/swap/reason#",
    "oboro": "http://obofoundry.org/ro/ro.owl#",
    "hxl": "http://hxl.humanitarianresponse.info/ns/#",
    "ecb": "http://ecb.270a.info/class/1.0/",
    "infosys": "http://www.infosys.com/",
    "cidoccrm": "http://purl.org/NET/cidoc-crm/core#",
    "pol": "http://escience.rpi.edu/ontology/semanteco/2/0/pollution.owl#",
    "swpo": "http://sw-portal.deri.org/ontologies/swportal#",
    "xbrli": "http://www.xbrl.org/2003/instance#",
    "atomowl": "http://bblfish.net/work/atom-owl/2006-06-06/#",
    "swanag": "http://purl.org/swan/1.2/agents/",
    "vocab": "http://rdf.ontology2.com/vocab#",
    "dbt": "http://dbpedia.org/resource/Template:",
    "dgfoaf": "http://west.uni-koblenz.de/ontologies/2010/07/dgfoaf.owl#",
    "aigp": "http://swat.cse.lehigh.edu/resources/onto/aigp.owl#",
    "shv": "http://ns.aksw.org/spatialHierarchy/",
    "pns": "http://data.press.net/ontology/stuff/",
    "pf": "http://jena.hpl.hp.com/ARQ/property#",
    "health": "http://purl.org/twc/health/vocab/",
    "govtrackus": "http://www.rdfabout.com/rdf/usgov/geo/us/",
    "gazetteer": "http://data.ordnancesurvey.co.uk/ontology/50kGazetteer/",
    "htir": "http://www.w3.org/2011/http#",
    "pna": "http://data.press.net/ontology/asset/",
    "admssw": "http://purl.org/adms/sw/",
    "wl": "http://www.wsmo.org/ns/wsmo-lite#",
    "pccz": "http://purl.org/procurement/public-contracts-czech#",
    "rad": "http://www.w3.org/ns/rad#",
    "oboinowl": "http://www.geneontology.org/formats/oboInOwl#",
    "oboso": "http://purl.org/obo/owl/SO#",
    "mte": "http://nl.ijs.si/ME/owl/",
    "set": "http://www.w3.org/2000/10/swap/set#",
    "wapp": "http://ns.rww.io/wapp#",
    "fl": "http://eulersharp.sourceforge.net/2003/03swap/fl-rules#",
    "csvw": "http://www.w3.org/ns/csvw#",
    "doco": "http://purl.org/spar/doco/",
    "dtype": "http://www.linkedmodel.org/schema/dtype#",
    "genab": "http://eulersharp.sourceforge.net/2003/03swap/genomeAbnormality#",
    "myprefix": "http://myprefix.org/",
    "protons": "http://proton.semanticweb.org/2005/04/protons#",
    "nocal": "http://vocab.deri.ie/nocal#",
    "frapo": "http://purl.org/cerif/frapo/",
    "mp": "http://jicamaro.info/mp#",
    "geofla": "http://data.ign.fr/ontologies/geofla#",
    "idemo": "http://rdf.insee.fr/def/demo#",
    "ends": "http://labs.mondeca.com/vocab/endpointStatus#",
    "rv": "http://wifo-ravensburg.de/semanticweb.rdf#",
    "wfm": "http://purl.org/net/wf-motifs#",
    "bridge": "http://purl.org/vocommons/bridge#",
    "wgspos": "http://www.w3.org/2003/01/geo/wgs84_pos#",
    "prolog": "http://eulersharp.sourceforge.net/2003/03swap/prolog#",
    "spif": "http://spinrdf.org/spif#",
    "italy": "http://data.kasabi.com/dataset/italy/schema/",
    "fcm": "http://eulersharp.sourceforge.net/2006/02swap/fcm#",
    "pne": "http://data.press.net/ontology/event/",
    "osr": "http://dati.senato.it/osr/",
    "clineva": "http://www.agfa.com/w3c/2009/clinicalEvaluation#",
    "ccard": "http://purl.org/commerce/creditcard#",
    "coun": "http://www.daml.org/2001/09/countries/iso-3166-ont#",
    "rating": "http://www.tvblob.com/ratings/#",
    "sgv": "http://www.w3.org/TR/SVG/",
    "kupkb": "http://www.e-lico.eu/data/kupkb/",
    "carfo": "http://purl.org/carfo#",
    "w3p": "http://prov4j.org/w3p/",
    "xt": "http://purl.org/twc/vocab/cross-topix#",
    "visko": "http://trust.utep.edu/visko/ontology/visko-operator-v3.owl#",
    "httpm": "http://www.w3.org/2011/http-methods#",
    "nyt": "http://data.nytimes.com/",
    "eseduc": "http://www.purl.org/ontologia/eseduc#",
    "penis": "http://penis.to/#",
    "artstor": "http://simile.mit.edu/2003/10/ontologies/artstor#",
    "cb": "http://cbasewrap.ontologycentral.com/vocab#",
    "rdaw": "http://rdaregistry.info/Elements/w/",
    "rlno": "http://rdflivenews.aksw.org/ontology/",
    "oax": "http://www.w3.org/ns/openannotation/extensions/",
    "xmls": "http://www.w3.org/2001/XMLSchema#",
    "aersv": "http://aers.data2semantics.org/vocab/",
    "tei": "http://www.tei-c.org/ns/1.0/",
    "func": "http://www.w3.org/2007/rif-builtin-function#",
    "loticoowl": "http://www.lotico.com/ontology/",
    "place": "http://purl.org/ontology/places/",
    "emp": "http://purl.org/ctic/empleo/oferta#",
    "ipad": "http://www.padinthecity.com/",
    "sdgp": "http://stats.data-gov.ie/property/",
    "eye": "http://jena.hpl.hp.com/Eyeball#",
    "hgnc": "http://bio2rdf.org/hgnc:",
    "nxp": "http://purl.org/nxp/schema/v1/",
    "telix": "http://purl.org/telix#",
    "lctr": "http://data.linkedct.org/vocab/resource/",
    "scowt": "http://purl.org/weso/ontologies/scowt#",
    "coeus": "http://bioinformatics.ua.pt/coeus/",
    "wsc": "http://www.openk.org/wscaim.owl#",
    "intervals": "http://reference.data.gov.uk/def/intervals/",
    "owls": "http://www.daml.org/services/owl-s/1.2/Service.owl#",
    "flow": "http://www.w3.org/2005/01/wf/flow#",
    "nytimes": "http://data.nytimes.com/elements/",
    "rso": "http://www.researchspace.org/ontology/",
    "dssn": "http://purl.org/net/dssn/",
    "rdfdf": "http://www.openlinksw.com/virtrdf-data-formats#",
    "osmsemnet": "http://spatial.ucd.ie/2012/08/osmsemnet/",
    "ufmedia": "http://purl.org/microformat/hmedia/",
    "wfdesc": "http://purl.org/wf4ever/wfdesc#",
    "oj": "http://ontojob.at/",
    "gxa": "http://www.ebi.ac.uk/gxa/",
    "soap": "http://www.w3.org/2003/05/soap-envelope/",
    "rs": "http://rightsstatements.org/vocab/",
    "saxon": "http://saxon.sf.net/",
    "poder": "http://poderopedia.com/vocab/",
    "crtv": "http://open-services.net/ns/crtv#",
    "vcardx": "http://buzzword.org.uk/rdf/vcardx#",
    "ogorg": "http://opengraph.org/schema/",
    "owltime": "http://www.w3.org/TR/owl-time#",
    "genea": "http://www.owl-ontologies.com/generations.owl#",
    "kw": "http://kwantu.net/kw/",
    "mtecore": "http://purl.org/olia/mte/multext-east.owl#",
    "centrifuge": "http://purl.org/twc/vocab/centrifuge#",
    "govwild": "http://govwild.org/0.6/GWOntology.rdf/",
    "dl": "http://ontology.ip.rm.cnr.it/ontologies/DOLCE-Lite#",
    "healthcare": "http://www.agfa.com/w3c/2009/healthCare#",
    "sad": "http://vocab.deri.ie/sad#",
    "osp": "http://data.lirmm.fr/ontologies/osp#",
    "rpubl": "http://rinfo.lagrummet.se/ns/2008/11/rinfo/publ#",
    "category": "http://dbpedia.org/resource/Category:",
    "cold": "http://purl.org/configurationontology#",
    "lod2": "http://lod2.eu/schema/",
    "r2rml": "http://www.w3.org/ns/r2rml#",
    "ecpo": "http://purl.org/ontology/ecpo#",
    "diseasome": "http://www4.wiwiss.fu-berlin.de/diseasome/resource/diseasome/",
    "humanbody": "http://eulersharp.sourceforge.net/2003/03swap/humanBody#",
    "fct": "http://openlinksw.com/services/facets/1.0/",
    "moby": "http://www.mygrid.org.uk/mygrid-moby-service#",
    "fc": "http://www.freeclass.eu/freeclass_v1#",
    "qu": "http://purl.oclc.org/NET/ssnx/qu/qu#",
    "p20": "http://zbw.eu/beta/p20/vocab/",
    "identity": "http://purl.org/twc/ontologies/identity.owl#",
    "pkmn": "http://pokedex.dataincubator.org/pkm/",
    "goef": "http://purl.org/twc/vocab/goef#",
    "daiaserv": "http://purl.org/ontology/daia/Service/",
    "pronom": "http://reference.data.gov.uk/technical-registry/",
    "meb": "http://rdf.myexperiment.org/ontologies/base/",
    "ngeoi": "http://vocab.lenka.no/geo-deling#",
    "environ": "http://eulersharp.sourceforge.net/2003/03swap/environment#",
    "fingal": "http://vocab.deri.ie/fingal#",
    "parl": "https://id.parliament.uk/schema/",
    "oac": "http://www.openannotation.org/ns/",
    "wf": "http://www.w3.org/2005/01/wf/flow#",
    "malignneo": "http://www.agfa.com/w3c/2009/malignantNeoplasm#",
    "npgd": "http://ns.nature.com/datasets/",
    "rich": "http://rdf.data-vocabulary.org/",
    "nsl": "http://purl.org/ontology/storyline/",
    "d2r": "http://sites.wiwiss.fu-berlin.de/suhl/bizer/d2r-server/config.rdf#",
    "lgv": "http://linkedgeodata.org/ontology/",
    "str": "http://nlp2rdf.lod2.eu/schema/string/",
    "s4ac": "http://ns.inria.fr/s4ac/v2#",
    "pam": "http://prismstandard.org/namespaces/pam/2.0/",
    "tvc": "http://www.essepuntato.it/2012/04/tvc/",
    "saref": "https://saref.etsi.org/core/",
    "nex": "http://www.nexml.org/2009/",
    "mohammad": "http://manesht.ir/",
    "ling": "http://purl.org/voc/ling/",
    "archdesc": "http://archdesc.info/archEvent#",
    "no": "http://km.aifb.kit.edu/projects/numbers/number#",
    "ekaw": "http://data.semanticweb.org/conference/ekaw/2012/complete/",
    "ec": "http://eulergui.sourceforge.net/contacts.owl.n3#",
    "grs": "http://www.georss.org/georss/",
    "dctypes": "http://purl.org/dc/dcmitype/",
    "atomrdf": "http://atomowl.org/ontologies/atomrdf#",
    "oecd": "http://oecd.270a.info/dataset/",
    "l4a": "http://labels4all.info/ns/",
    "ql": "http://www.w3.org/2004/ql#",
    "wscaim": "http://www.openk.org/wscaim.owl#",
    "marshall": "http://sites.google.com/site/xgmaitc/",
    "frad": "http://iflastandards.info/ns/fr/frad/",
    "okg": "http://openknowledgegraph.org/ontology/",
    "npgg": "http://ns.nature.com/graphs/",
    "clinproc": "http://www.agfa.com/w3c/2009/clinicalProcedure#",
    "aerols": "http://xmlns.com/aerols/0.1/",
    "ru": "http://purl.org/imbi/ru-meta.owl#",
    "wkd": "http://schema.wolterskluwer.de/",
    "hcard": "http://purl.org/uF/hCard/terms/",
    "wm": "http://ns.inria.fr/webmarks#",
    "itsmo": "http://ontology.it/itsmo/v1#",
    "gbv": "http://purl.org/ontology/gbv/",
    "tripfs2": "http://purl.org/tripfs/2010/06#",
    "puelia": "http://kwijibo.talis.com/vocabs/puelia#",
    "wfprov": "http://purl.org/wf4ever/wfprov#",
    "gesis": "http://lod.gesis.org/lodpilot/ALLBUS/vocab.rdf#",
    "l4lod": "http://ns.inria.fr/l4lod/v2/",
    "camelot": "http://vocab.ox.ac.uk/camelot#",
    "iron": "http://purl.org/ontology/iron#",
    "bcncon": "http://datos.bcn.cl/ontologies/bcn-congress#",
    "geop": "http://aims.fao.org/aos/geopolitical.owl#",
    "s2s": "http://escience.rpi.edu/ontology/sesf/s2s/4/0/",
    "openskos": "http://openskos.org/xmlns#",
    "biordf": "http://purl.org/net/biordfmicroarray/ns#",
    "opmw": "http://www.opmw.org/ontology/",
    "lh": "http://vocab.inf.ed.ac.uk/library/holdings#",
    "mpeg7": "http://rhizomik.net/ontologies/2005/03/Mpeg7-2001.owl#",
    "gfo": "http://www.onto-med.de/ontologies/gfo.owl#",
    "frbrcore": "http://purl.org/vocab/frbr/core#",
    "prism21": "http://prismstandard.org/namespaces/basic/2.1/",
    "hartigprov": "http://purl.org/net/provenance/ns#",
    "geovocab": "http://geovocab.org/",
    "occult": "http://data.totl.net/occult/",
    "cdtype": "http://purl.org/cld/cdtype/",
    "gist": "https://ontologies.semanticarts.com/gist/",
    "kbp": "http://tackbp.org/2013/ontology#",
    "c4dm": "http://purl.org/NET/c4dm/event.owl#",
    "protegedc": "http://protege.stanford.edu/plugins/owl/dc/protege-dc.owl#",
    "cis": "http://purl.org/NET/cloudisus#",
    "laposte": "http://data.lirmm.fr/ontologies/laposte#",
    "va": "http://code-research.eu/ontology/visual-analytics#",
    "bcnnorms": "http://datos.bcn.cl/ontologies/bcn-norms#",
    "b2rpubchem": "http://bio2rdf.org/ns/ns/ns/pubchem#",
    "odcs": "http://opendata.cz/infrastructure/odcleanstore/",
    "campsite": "http://www.openlinksw.com/campsites/schema#",
    "bm": "http://bio2rdf.org/",
    "luc": "http://www.ontotext.com/owlim/lucene#",
    "dbyago": "http://dbpedia.org/class/yago/",
    "rec54": "http://www.w3.org/2001/02pd/rec54.rdf#",
    "namespaces": "https://vg.no/",
    "skiresort": "http://www.openlinksw.com/ski_resorts/schema#",
    "cmd": "http://clarin.eu/cmd#",
    "esdir": "http://vocab.linkeddata.es/datosabiertos/def/urbanismo-infraestructuras/direccion-postal#",
    "gastro": "http://www.ebsemantics.net/gastro#",
    "cdt": "https://w3id.org/cdt/",
    "frame": "http://www.ontologydesignpatterns.org/ont/framenet/abox/frame/",
    "vsto": "http://escience.rpi.edu/ontology/vsto/2/0/vsto.owl#",
    "te": "http://www.w3.org/2006/time-entry#",
    "osukdt": "http://www.ordnancesurvey.co.uk/ontology/Datatypes.owl#",
    "zoomaterms": "http://rdf.ebi.ac.uk/vocabulary/zooma/",
    "stac": "http://securitytoolbox.appspot.com/stac#",
    "transmed": "http://www.w3.org/2001/sw/hcls/ns/transmed/",
    "ebu": "http://semantic.eurobau.com/eurobau-utility.owl#",
    "mil": "http://rdf.muninn-project.org/ontologies/military#",
    "dawgt": "http://www.w3.org/2001/sw/DataAccess/tests/test-dawg#",
    "sioctypes": "http://rdfs.org/sioc/types#",
    "scms": "http://ns.aksw.org/scms/annotations/",
    "hints2005": "http://purl.org/twc/cabig/model/HINTS2005-1.owl#",
    "cf": "http://mmisw.org/ont/cf/parameter/",
    "fe": "http://www.ontologydesignpatterns.org/ont/framenet/abox/fe/",
    "harrisons": "http://harrisons.cc/",
    "sci": "http://data.scientology.org/ns/",
    "pizza": "http://www.co-ode.org/ontologies/pizza/pizza.owl#",
    "quantities": "http://eulersharp.sourceforge.net/2003/03swap/quantitiesExtension#",
    "psh": "http://psh.techlib.cz/skos/",
    "skos08": "http://www.w3.org/2008/05/skos#",
    "tisc": "http://observedchange.com/tisc/ns#",
    "germplasm": "http://purl.org/germplasm/terms#",
    "ptop": "http://www.ontotext.com/proton/protontop#",
    "opl": "http://openlinksw.com/schema/attribution#",
    "curr": "https://w3id.org/cc#",
    "msr": "http://www.telegraphis.net/ontology/measurement/measurement#",
    "csm": "http://purl.org/csm/1.0#",
    "ops": "https://w3id.org/ops#",
    "fos": "http://futurios.org/fos/spec/",
    "sw": "http://linkedwidgets.org/statisticalwidget/ontology/",
    "osspr": "http://data.ordnancesurvey.co.uk/ontology/spatialrelations/",
    "rssynd": "http://web.resource.org/rss/1.0/modules/syndication/",
    "dcndl": "http://ndl.go.jp/dcndl/terms/",
    "cdc": "https://w3id.org/cdc#",
    "crv": "http://purl.org/twc/vocab/datacarver#",
    "ds": "http://purl.org/ctic/dcat#",
    "pso": "http://purl.org/spar/pso/",
    "hifm": "http://purl.org/net/hifm/data#",
    "sor": "http://purl.org/net/soron/",
    "dpl": "http://dbpedialite.org/things/",
    "qvoc": "http://mlode.nlp2rdf.org/quranvocab#",
    "spt": "http://spitfire-project.eu/ontology/ns/",
    "wno": "http://wordnet-rdf.princeton.edu/ontology#",
    "bihap": "http://bihap.kb.gov.tr/ontology/",
    "disease": "http://www.agfa.com/w3c/2009/humanDisorder#",
    "gov": "http://gov.genealogy.net/ontology.owl#",
    "seq": "http://www.ontologydesignpatterns.org/cp/owl/sequence.owl#",
    "paia": "http://purl.org/ontology/paia#",
    "rdapo": "http://rdaregistry.info/Elements/p/object/",
    "bv": "http://purl.org/vocommons/bv#",
    "steel": "http://ontorule-project.eu/resources/steel-30#",
    "oarj": "http://opendepot.org/reference/linked/1.0/",
    "sso": "http://nlp2rdf.lod2.eu/schema/sso/",
    "pubmed": "http://bio2rdf.org/pubmed_vocabulary:",
    "lc": "http://semweb.mmlab.be/ns/linkedconnections#",
    "mads": "http://www.loc.gov/mads/rdf/v1#",
    "fo": "http://purl.org/ontology/fo/",
    "wsl": "http://www.wsmo.org/ns/wsmo-lite#",
    "prvt": "http://purl.org/net/provenance/types#",
    "abs": "http://abs.270a.info/dataset/",
    "part": "http://purl.org/vocab/participation/schema#",
    "qrl": "http://www.aifb.kit.edu/project/ld-retriever/qrl#",
    "cts2": "http://schema.omg.org/spec/CTS2/1.0/",
    "omnlife": "http://open-multinet.info/ontology/omn-lifecycle#",
    "vgo": "http://purl.org/net/VideoGameOntology#",
    "alchemy": "http://rdf.alchemyapi.com/rdf/v1/s/aapi-schema#",
    "estrn": "http://vocab.linkeddata.es/datosabiertos/def/urbanismo-infraestructuras/transporte#",
    "telmap": "http://purl.org/telmap/",
    "eumida": "http://data.kasabi.com/dataset/eumida/terms/",
    "coll": "http://purl.org/co/",
    "tblcard": "http://www.w3.org/People/Berners-Lee/card#",
    "omapi": "http://purl.org/omapi/0.2/#",
    "conf": "http://richard.cyganiak.de/2007/pubby/config.rdf#",
    "ep": "http://eprints.org/ontology/",
    "of": "http://owlrep.eu01.aws.af.cm/fridge#",
    "vin": "http://www.w3.org/TR/2003/PR-owl-guide-20031209/wine#",
    "li": "http://def.seegrid.csiro.au/isotc211/iso19115/2003/lineage#",
    "refe": "http://orion.tw.rpi.edu/~xgmatwc/refe/",
    "op": "http://environment.data.gov.au/def/op#",
    "infor": "http://www.ontologydesignpatterns.org/cp/owl/informationrealization.owl#",
    "sro": "http://salt.semanticauthoring.org/ontologies/sro#",
    "rdae": "http://rdaregistry.info/Elements/e/",
    "water": "http://escience.rpi.edu/ontology/semanteco/2/0/water.owl#",
    "my": "http://www.mobile.com/model/",
    "ecc": "https://ns.eccenca.com/",
    "dvia": "http://data.eurecom.fr/ontology/dvia#",
    "aers": "http://aers.data2semantics.org/resource/",
    "onyx": "http://www.gsi.dit.upm.es/ontologies/onyx/ns#",
    "ldr": "http://purl.oclc.org/NET/ldr/ns#",
    "npgx": "http://ns.nature.com/extensions/",
    "daisy": "http://www.daisy.org/z3998/2012/vocab/",
    "daq": "http://purl.org/eis/vocab/daq#",
    "elec": "http://purl.org/ctic/sector-publico/elecciones#",
    "stream": "http://dbpedia.org/ontology/Stream/",
    "od": "http://purl.org/twc/vocab/opendap#",
    "biro": "http://purl.org/spar/biro/",
    "moac": "http://observedchange.com/moac/ns#",
    "fma": "http://sig.uw.edu/fma#",
    "cart": "http://purl.org/net/cartCoord#",
    "dcite": "http://purl.org/spar/datacite/",
    "cosmo": "http://purl.org/ontology/cosmo#",
    "webbox": "http://webbox.ecs.soton.ac.uk/ns#",
    "fincaselaw": "http://purl.org/finlex/schema/oikeus/",
    "strdf": "http://strdf.di.uoa.gr/ontology#",
    "wlo": "http://purl.org/ontology/wo/",
    "html": "http://www.w3.org/1999/xhtml/",
    "lldr": "http://purl.oclc.org/NET/lldr/ns#",
    "eunis": "http://eunis.eea.europa.eu/rdf/species-schema.rdf#",
    "vsw": "http://verticalsearchworks.com/ontology/",
    "emoca": "http://ns.inria.fr/emoca#",
    "w3con": "http://www.w3.org/2000/10/swap/pim/contact#",
    "mt": "http://www.w3.org/2001/sw/DataAccess/tests/test-manifest#",
    "lso": "http://linkedspending.aksw.org/ontology/",
    "rdacarrier": "http://rdvocab.info/termList/RDACarrierType/",
    "fno": "https://w3id.org/function/ontology#",
    "data": "http://data.odw.tw/",
    "vf": "https://w3id.org/valueflows#",
    "mged": "http://mged.sourceforge.net/ontologies/MGEDOntology.owl#",
    "lexvo": "http://lexvo.org/ontology#",
    "mb": "http://dbtune.org/musicbrainz/resource/instrument/",
    "ipo": "http://purl.org/ipo/core#",
    "ecos": "http://kmm.lboro.ac.uk/ecos/1.0#",
    "sdmxd": "http://purl.org/linked-data/sdmx/2009/dimension#",
    "mrel": "http://id.loc.gov/vocabulary/relators/",
    "finlaw": "http://purl.org/finlex/schema/laki/",
    "bwb": "http://doc.metalex.eu/bwb/ontology/",
    "rdamedia": "http://rdvocab.info/termList/RDAMediaType/",
    "rdarel": "http://rdvocab.info/RDARelationshipsWEMI/",
    "odo": "http://ocean-data.org/schema/",
    "turismo": "http://idi.fundacionctic.org/cruzar/turismo#",
    "qud": "http://qudt.org/1.1/schema/qudt#",
    "sdm": "https://w3id.org/okn/o/sdm#",
    "lodac": "http://lod.ac/ns/lodac#",
    "dr": "http://purl.org/swan/2.0/discourse-relationships/",
    "iol": "http://www.ontologydesignpatterns.org/ont/dul/IOLite.owl#",
    "osgeom": "http://data.ordnancesurvey.co.uk/ontology/geometry/",
    "ox": "http://vocab.ox.ac.uk/projectfunding#",
    "eui": "http://institutions.publicdata.eu/#",
    "wikterms": "http://wiktionary.dbpedia.org/terms/",
    "vsws": "http://verticalsearchworks.com/ontology/synset#",
    "prviv": "http://purl.org/net/provenance/integrity#",
    "swperson": "http://data.semanticweb.org/person/",
    "swpatho": "http://swpatho.ag-nbi.de/context/meta.owl#",
    "bcnbio": "http://datos.bcn.cl/ontologies/bcn-biographies#",
    "cl": "http://advene.org/ns/cinelab/",
    "lsc": "http://linkedscience.org/lsc/ns#",
    "fcp": "http://www.newmedialab.at/fcp/",
    "bk": "http://www.provbook.org/ns/#",
    "lcy": "http://purl.org/vocab/lifecycle/schema#",
    "ssso": "http://purl.org/ontology/ssso#",
    "drm": "http://vocab.data.gov/def/drm#",
    "dqm": "http://purl.org/dqm-vocabulary/v1/dqm#",
    "plo": "http://purl.org/net/po#",
    "solid": "http://www.w3.org/ns/solid/terms#",
    "radion": "http://www.w3.org/ns/radion#",
    "quty": "http://www.telegraphis.net/ontology/measurement/quantity#",
    "vrank": "http://purl.org/voc/vrank#",
    "shw": "http://paul.staroch.name/thesis/SmartHomeWeather.owl#",
    "dcoid": "http://dx.deepcarbon.net/",
    "jjd": "http://www.joshuajeeson.com/",
    "nidm": "http://nidm.nidash.org/",
    "ecrm": "http://erlangen-crm.org/current/",
    "who": "http://www.who.int/vocab/ontology#",
    "cbase": "http://ontologycentral.com/2010/05/cb/vocab#",
    "r4ta": "http://ns.inria.fr/ratio4ta/v1#",
    "guo": "http://purl.org/hpi/guo#",
    "semio": "http://www.lingvoj.org/semio#",
    "situ": "http://www.ontologydesignpatterns.org/cp/owl/situation.owl#",
    "twaapi": "http://purl.org/twc/vocab/aapi-schema#",
    "psys": "http://proton.semanticweb.org/protonsys#",
    "poste": "http://data.lirmm.fr/ontologies/poste#",
    "saif": "http://wwwiti.cs.uni-magdeburg.de/~srahman/",
    "doas": "http://deductions.github.io/doas.owl.ttl#",
    "roevo": "http://purl.org/wf4ever/roevo#",
    "graffle": "http://purl.org/twc/vocab/vsr/graffle#",
    "lio": "http://purl.org/net/lio#",
    "dn": "http://purl.org/datanode/ns/",
    "gadm": "http://gadm.geovocab.org/ontology#",
    "ordf": "http://purl.org/NET/ordf/",
    "voidp": "http://www.enakting.org/provenance/voidp/",
    "opmo": "http://openprovenance.org/model/opmo#",
    "smg": "http://ns.cerise-project.nl/energy/def/cim-smartgrid#",
    "onc": "http://www.ics.forth.gr/isl/oncm/core#",
    "particip": "http://purl.org/vocab/participation/schema#",
    "opllic": "http://www.openlinksw.com/ontology/licenses#",
    "oslo": "http://purl.org/oslo/ns/localgov#",
    "geocontext": "http://www.geocontext.org/publ/2013/vocab#",
    "infection": "http://www.agfa.com/w3c/2009/infectiousDisorder#",
    "vdpp": "http://data.lirmm.fr/ontologies/vdpp#",
    "rdacontent": "http://rdvocab.info/termList/RDAContentType/",
    "viskoo": "http://trust.utep.edu/visko/ontology/visko-operator-v3.owl#",
    "accom": "http://purl.org/acco/ns#",
    "pingback": "http://purl.org/net/pingback/",
    "ebucore": "http://www.ebu.ch/metadata/ontologies/ebucore/ebucore#",
    "cpant": "http://purl.org/NET/cpan-uri/terms#",
    "biotop": "http://purl.org/biotop/biotop.owl#",
    "pnt": "http://data.press.net/ontology/tag/",
    "dpc": "http://hospee.org/ontologies/dpc/",
    "tw": "http://tw.rpi.edu/schema/",
    "ctorg": "http://purl.org/ctic/infraestructuras/organizacion#",
    "chembl": "http://rdf.ebi.ac.uk/terms/chembl#",
    "onssprel": "http://www.ordnancesurvey.co.uk/ontology/SpatialRelations/v0.2/SpatialRelations.owl#",
    "csp": "http://vocab.deri.ie/csp#",
    "pod": "https://project-open-data.cio.gov/v1.1/schema/#",
    "asgv": "http://aims.fao.org/aos/agrovoc/",
    "gawd": "http://gawd.atlantides.org/terms/",
    "viskov": "http://trust.utep.edu/visko/ontology/visko-view-v3.owl#",
    "rlnr": "http://rdflivenews.aksw.org/resource/",
    "trait": "http://contextus.net/ontology/ontomedia/ext/common/trait#",
    "tis": "http://www.ontologydesignpatterns.org/cp/owl/timeindexedsituation.owl#",
    "odapp": "http://vocab.deri.ie/odapp#",
    "sam": "http://def.seegrid.csiro.au/isotc211/iso19156/2011/sampling#",
    "pois": "http://purl.oclc.org/POIS/vcblr#",
    "qb4o": "http://purl.org/olap#",
    "pattern": "http://www.essepuntato.it/2008/12/pattern#",
    "dogont": "http://elite.polito.it/ontologies/dogont.owl#",
    "dbpr": "http://dbpedia.org/resource/",
    "mvco": "http://purl.oclc.org/NET/mvco.owl#",
    "date": "http://contextus.net/ontology/ontomedia/misc/date#",
    "tac": "http://ns.bergnet.org/tac/0.1/triple-access-control#",
    "lingvo": "http://www.lingvoj.org/ontology#",
    "rmo": "http://eatld.et.tu-dresden.de/rmo#",
    "vvo": "http://purl.org/vvo/ns#",
    "pkgsrc": "http://pkgsrc.co/schema#",
    "ses": "http://lod.taxonconcept.org/ses/",
    "odv": "http://reference.data.gov.uk/def/organogram/",
    "roterms": "http://purl.org/wf4ever/roterms#",
    "frbrer": "http://iflastandards.info/ns/fr/frbr/frbrer/",
    "evident": "http://purl.org/net/evident#",
    "oss": "http://opendata.caceres.es/def/ontosemanasanta#",
    "esco": "http://data.europa.eu/esco/model#",
    "mmd": "http://musicbrainz.org/ns/mmd-1.0#",
    "fam": "http://vocab.fusepool.info/fam#",
    "mico": "http://www.mico-project.eu/ns/platform/1.0/schema#",
    "ntag": "http://ns.inria.fr/nicetag/2010/09/09/voc#",
    "vapour": "http://vapour.sourceforge.net/vocab.rdf#",
    "icane": "http://www.icane.es/opendata/vocab#",
    "lexcz": "http://purl.org/lex/cz#",
    "verb": "https://w3id.org/verb/",
    "agls": "http://www.agls.gov.au/agls/terms/",
    "pwo": "http://purl.org/spar/pwo/",
    "xlime": "http://xlime-project.org/vocab/",
    "w3po": "http://purl.org/provenance/w3p/w3po#",
    "bgn": "http://bibliograph.net/schemas/",
    "goog": "http://schema.googleapis.com/",
    "json": "https://www.ecma-international.org/publications/files/ECMA-ST/ECMA-404.pdf#",
    "cvbase": "http://purl.org/captsolo/resume-rdf/0.2/base#",
    "deps": "http://ontologi.es/doap-deps#",
    "graves": "http://rdf.muninn-project.org/ontologies/graves#",
    "olad": "http://openlad.org/vocab#",
    "tsioc": "http://rdfs.org/sioc/types#",
    "opencyc": "http://sw.opencyc.org/concept/",
    "gcis": "http://data.globalchange.gov/gcis.owl#",
    "stats": "http://purl.org/rdfstats/stats#",
    "rdarole": "http://rdvocab.info/roles/",
    "oecc": "http://www.oegov.org/core/owl/cc#",
    "lindt": "http://purl.org/NET/lindt#",
    "delta": "http://www.w3.org/2004/delta#",
    "frsad": "http://iflastandards.info/ns/fr/frsad/",
    "frb": "http://frb.270a.info/dataset/",
    "rdl": "http://data.posccaesar.org/rdl/",
    "locwd": "http://purl.org/locwd/schema#",
    "thors": "http://resource.geosciml.org/ontology/timescale/thors#",
    "crmdig": "http://www.ics.forth.gr/isl/CRMdig/",
    "fao": "http://fao.270a.info/dataset/",
    "call": "http://webofcode.org/wfn/call:",
    "gl": "http://schema.geolink.org/",
    "gm": "http://def.seegrid.csiro.au/isotc211/iso19107/2003/geometry#",
    "ost": "http://w3id.org/ost/ns#",
    "obsm": "http://rdf.geospecies.org/methods/observationMethod#",
    "dbcat": "http://dbpedia.org/resource/Category:",
    "scufl2": "http://ns.taverna.org.uk/2010/scufl2#",
    "rdarel2": "http://metadataregistry.org/uri/schema/RDARelationshipsGR2/",
    "fcs": "http://clarin.eu/fcs/resource#",
    "wro": "http://purl.org/net/wf4ever/ro#",
    "bn": "http://babelnet.org/rdf/",
    "uta": "http://uptheasset.org/ontology#",
    "viso": "http://purl.org/viso/",
    "tp": "https://triplydb.com/Triply/tp/def/",
    "ostop": "http://www.ordnancesurvey.co.uk/ontology/Topography/v0.1/Topography.owl#",
    "ogbd": "http://www.ogbd.fr/2012/ontologie#",
    "owlse": "http://www.daml.org/services/owl-s/1.2/generic/Expression.owl#",
    "yo": "http://yovisto.com/",
    "rdai": "http://rdaregistry.info/Elements/i/",
    "dbpedia2": "http://dbpedia.org/property/",
    "kai": "http://kai.uni-kiel.de/",
    "bgcat": "http://bg.dbpedia.org/resource/?????????:",
    "app": "http://jmvanel.free.fr/ontology/software_applications.n3#",
    "agro": "http://purl.obolibrary.org/obo/agro.owl#",
    "hlygt": "http://www.holygoat.co.uk/owl/redwood/0.1/tags/",
    "oplprod": "http://www.openlinksw.com/ontology/products#",
    "gnm": "http://www.geonames.org/ontology/mappings/",
    "cpsv": "http://purl.org/vocab/cpsv#",
    "geosp": "http://rdf.geospecies.org/ont/geospecies#",
    "provone": "http://purl.org/provone#",
    "dbtont": "http://dbtropes.org/ont/",
    "rdamt": "http://rdaregistry.info/termList/RDAMediaType/",
    "shoah": "http://dati.cdec.it/lod/shoah/",
    "snarm": "http://rdf.myexperiment.org/ontologies/snarm/",
    "vcard2006": "http://www.w3.org/2006/vcard/ns#",
    "rdafrbr": "http://rdvocab.info/uri/schema/FRBRentitiesRDA/",
    "amalgame": "http://purl.org/vocabularies/amalgame#",
    "pnc": "http://data.press.net/ontology/classification/",
    "latitude": "https://www.w3.org/2006/vcard/ns#latitude#",
    "scoro": "http://purl.org/spar/scoro/",
    "mammal": "http://lod.taxonconcept.org/ontology/p01/Mammalia/index.owl#",
    "dannet": "http://www.wordnet.dk/owl/instance/2009/03/instances/",
    "emtr": "http://purl.org/NET/ssnext/electricmeters#",
    "atlas": "http://rdf.ebi.ac.uk/resource/atlas/",
    "wf4ever": "http://purl.org/wf4ever/wf4ever#",
    "gnvc": "http://purl.org/gc/",
    "wn20": "http://www.w3.org/2006/03/wn/wn20/",
    "mv": "http://schema.mobivoc.org/",
    "mesh": "http://purl.bioontology.org/ontology/MESH/",
    "gf": "http://def.seegrid.csiro.au/isotc211/iso19109/2005/feature#",
    "bcngeo": "http://datos.bcn.cl/ontologies/bcn-geographics#",
    "dcatapit": "http://dati.gov.it/onto/dcatapit#",
    "holding": "http://purl.org/ontology/holding#",
    "td": "https://www.w3.org/2019/wot/td#",
    "ontopic": "http://www.ontologydesignpatterns.org/ont/dul/ontopic.owl#",
    "crsw": "http://courseware.rkbexplorer.com/ontologies/courseware#",
    "raul": "http://vocab.deri.ie/raul#",
    "gq": "http://genomequest.com/",
    "uis": "http://uis.270a.info/dataset/",
    "oan": "http://data.lirmm.fr/ontologies/oan/",
    "grel": "http://users.ugent.be/~bjdmeest/function/grel.ttl#",
    "wikibase": "http://wikiba.se/ontology#",
    "lmm1": "http://www.ontologydesignpatterns.org/ont/lmm/LMM_L1.owl#",
    "s3db": "http://www.s3db.org/core#",
    "dpd": "http://www.kanzaki.com/ns/dpd#",
    "nxs": "http://www.neclimateus.org/",
    "art": "http://w3id.org/art/terms/1.0/",
    "static": "http://vocab-ld.org/vocab/static-ld#",
    "bner": "http://datos.bne.es/resource/",
    "isocat": "http://www.isocat.org/datcat/",
    "oplcert": "http://www.openlinksw.com/schemas/cert#",
    "ls": "http://linkedspending.aksw.org/instance/",
    "limoo": "http://purl.org/LiMo/0.1/",
    "mmf": "http://linkedmultimedia.org/sparql-mm/ns/1.0.0/function#",
    "lmm2": "http://www.ontologydesignpatterns.org/ont/lmm/LMM_L2.owl#",
    "cjr": "http://vocab.linkeddata.es/datosabiertos/def/urbanismo-infraestructuras/callejero#",
    "pproc": "http://contsem.unizar.es/def/sector-publico/pproc#",
    "rdf123": "http://rdf123.umbc.edu/ns/",
    "xrd": "http://docs.oasis-open.org/ns/xri/xrd-1.0#",
    "xapi": "https://w3id.org/xapi/ontology#",
    "location": "http://sw.deri.org/2006/07/location/loc#",
    "rdag1": "http://rdvocab.info/Elements/",
    "pni": "http://data.press.net/ontology/identifier/",
    "muldicat": "http://iflastandards.info/ns/muldicat#",
    "sbench": "http://swat.cse.lehigh.edu/onto/univ-bench.owl#",
    "nerd": "http://nerd.eurecom.fr/ontology#",
    "bco": "http://purl.obolibrary.org/obo/bco.owl#",
    "lden": "http://www.linklion.org/lden/",
    "ccrel": "http://creativecommons.org/ns#",
    "c9d": "http://purl.org/twc/vocab/conversion/",
    "geod": "http://vocab.lenka.no/geo-deling#",
    "pkm": "http://www.ontotext.com/proton/protonkm#",
    "edgar": "http://edgarwrap.ontologycentral.com/vocab/edgar#",
    "sao": "http://salt.semanticauthoring.org/ontologies/sao#",
    "bbcprov": "http://www.bbc.co.uk/ontologies/provenance/",
    "ljkl": "http://teste.com/",
    "oprovo": "http://openprovenance.org/ontology#",
    "rdagw": "http://rdaregistry.info/termList/grooveWidth/",
    "kees": "http://linkeddata.center/kees/v1#",
    "form": "http://deductions-software.com/ontologies/forms.owl.ttl#",
    "msm": "http://iserve.kmi.open.ac.uk/ns/msm#",
    "stories": "http://purl.org/ontology/stories/",
    "wikim": "http://spi-fm.uca.es/spdef/models/genericTools/wikim/1.0#",
    "topo": "http://data.ign.fr/def/topo#",
    "dbptmpl": "http://dbpedia.org/resource/Template:",
    "pvcs": "http://purl.org/twc/vocab/pvcs#",
    "quantity": "http://qudt.org/schema/quantity#",
    "ext": "http://def.seegrid.csiro.au/isotc211/iso19115/2003/extent#",
    "oh": "http://semweb.mmlab.be/ns/oh#",
    "insdc": "http://ddbj.nig.ac.jp/ontologies/sequence#",
    "contsem": "http://contsem.unizar.es/def/sector-publico/contratacion#",
    "clinic": "http://example.com/clinic#",
    "wb": "http://data.worldbank.org/",
    "origins": "http://origins.link/",
    "imf": "http://imf.270a.info/dataset/",
    "rkd": "http://data.rkd.nl/def#",
    "mds": "http://doc.metalex.eu/id/",
    "gaf": "http://groundedannotationframework.org/",
    "llo": "http://lodlaundromat.org/ontology/",
    "oml": "http://def.seegrid.csiro.au/ontology/om/om-lite#",
    "rankrage": "https://rankrage.de/",
    "faq": "http://www.openlinksw.com/ontology/faq#",
    "defns": "http://www.openarchives.org/OAI/2.0/",
    "ll": "http://lodlaundromat.org/resource/",
    "being": "http://purl.org/ontomedia/ext/common/being#",
    "esaloj": "http://vocab.linkeddata.es/datosabiertos/def/turismo/alojamiento#",
    "osadm": "http://data.ordnancesurvey.co.uk/ontology/admingeo/",
    "limo": "http://www.purl.org/limo-ontology/limo#",
    "hr": "http://iserve.kmi.open.ac.uk/ns/hrests#",
    "odpart": "http://www.ontologydesignpatterns.org/cp/owl/participation.owl#",
    "eurlex": "http://eur-lex.publicdata.eu/ontology/",
    "rdafr": "http://rdaregistry.info/termList/frequency/",
    "tao": "http://vocab.deri.ie/tao#",
    "maso": "http://securitytoolbox.appspot.com/MASO#",
    "cmdm": "http://infra.clarin.eu/cmd/",
    "rdacct": "http://rdaregistry.info/termList/CollTitle/",
    "dq": "http://def.seegrid.csiro.au/isotc211/iso19115/2003/dataquality#",
    "sosa": "http://www.w3.org/ns/sosa/",
    "esequip": "http://vocab.linkeddata.es/datosabiertos/def/urbanismo-infraestructuras/equipamiento#",
    "rdatc": "http://rdaregistry.info/termList/trackConfig/",
    "laabs": "http://dbpedia.org/resource/",
    "lda": "http://purl.org/linked-data/api/vocab#",
    "aws": "http://purl.oclc.org/NET/ssnx/meteo/aws#",
    "passim": "http://data.lirmm.fr/ontologies/passim#",
    "rdafnm": "http://rdaregistry.info/termList/FormNoteMus/",
    "security": "http://securitytoolbox.appspot.com/securityMain#",
    "omdoc": "http://omdoc.org/ontology/",
    "decision": "https://decision-ontology.googlecode.com/svn/trunk/decision.owl#",
    "scor": "http://purl.org/eis/vocab/scor#",
    "dcs": "http://ontologi.es/doap-changeset#",
    "sru": "http://www.loc.gov/zing/srw/",
    "eurostat": "http://wifo5-04.informatik.uni-mannheim.de/eurostat/resource/eurostat/",
    "vext": "http://ldf.fi/void-ext#",
    "rdfdata": "http://rdf.data-vocabulary.org/rdf.xml#",
    "odrs": "http://schema.theodi.org/odrs#",
    "ldvm": "http://linked.opendata.cz/ontology/ldvm/",
    "scip": "http://lod.taxonconcept.org/ontology/sci_people.owl#",
    "bis": "http://bis.270a.info/dataset/",
    "rvdata": "http://data.rvdata.us/",
    "ramon": "http://rdfdata.eionet.europa.eu/ramon/ontology/",
    "citof": "http://www.essepuntato.it/2013/03/cito-functions#",
    "rdag3": "http://rdvocab.info/ElementsGr3/",
    "rdasoi": "http://rdaregistry.info/termList/statIdentification/",
    "employee": "http://www.employee.com/data#",
    "ftcontent": "http://www.ft.com/ontology/content/",
    "wn31": "http://wordnet-rdf.princeton.edu/wn31/",
    "oliasystem": "http://purl.org/olia/system.owl#",
    "pco": "http://purl.org/procurement/public-contracts#",
    "mocanal": "http://www.semanticweb.org/asow/ontologies/2013/9/untitled-ontology-36#",
    "spdx": "http://spdx.org/rdf/terms#",
    "dqv": "http://www.w3.org/ns/dqv#",
    "d2d": "http://rdfns.org/d2d/",
    "hasco": "http://hadatac.org/ont/hasco/",
    "shex": "http://www.w3.org/ns/shex#",
    "geos": "http://www.telegraphis.net/ontology/geography/geography#",
    "rdagd": "http://rdaregistry.info/termList/gender/",
    "rml": "http://semweb.mmlab.be/ns/rml#",
    "ogc": "http://www.opengis.net/def/",
    "tm": "http://def.seegrid.csiro.au/isotc211/iso19108/2002/temporal#",
    "affymetrix": "http://bio2rdf.org/affymetrix_vocabulary:",
    "foo": "http://filmontology.org/ontology/1.0/",
    "cmdi": "http://www.clarin.eu/cmd/",
    "lofv": "http://purl.org/legal_form/vocab#",
    "agrd": "http://agrinepaldata.com/",
    "lexicon": "http://www.example.org/lexicon#",
    "tddo": "http://databugger.aksw.org/ns/core#",
    "spfood": "http://kmi.open.ac.uk/projects/smartproducts/ontologies/food.owl#",
    "jp1": "http://rdf.muninn-project.org/ontologies/jp1/",
    "lsmap": "http://ontology.cybershare.utep.edu/ELSEWeb/elseweb-data.owl#",
    "shacl": "http://www.w3.org/ns/shacl#",
    "csv": "http://vocab.sindice.net/csv/",
    "auto": "http://auto.schema.org/",
    "vmm": "http://spi-fm.uca.es/spdef/models/genericTools/vmm/1.0#",
    "saws": "http://purl.org/saws/ontology#",
    "beth": "http://www.google.com/",
    "galaksiya": "http://ontoloji.galaksiya.com/vocab/",
    "bevon": "http://rdfs.co/bevon/",
    "lw": "http://linkedwidgets.org/ontologies/",
    "allot": "https://w3id.org/akn/ontology/allot#",
    "ecgl": "http://schema.geolink.org/",
    "oils": "http://lemon-model.net/oils#",
    "friends": "http://www.openarchives.org/OAI/2.0/friends/",
    "phdd": "http://rdf-vocabulary.ddialliance.org/phdd#",
    "rdami": "http://rdaregistry.info/termList/modeIssue/",
    "physo": "http://merlin.phys.uni.lodz.pl/onto/physo/physo.owl#",
    "npdv": "http://sws.ifi.uio.no/vocab/npd#",
    "rdabm": "http://rdaregistry.info/termList/RDABaseMaterial/",
    "lsd": "http://linkedwidgets.org/statisticaldata/ontology/",
    "lpeu": "http://purl.org/linkedpolitics/vocabulary/eu/plenary/",
    "language": "http://id.loc.gov/vocabulary/iso639-1/",
    "pic": "http://www.ipaw.info/ns/picaso#",
    "opengov": "http://www.w3.org/opengov#",
    "euvoc": "http://publications.europa.eu/ontology/euvoc#",
    "xcql": "http://docs.oasis-open.org/ns/search-ws/xcql#",
    "mmt": "http://linkedmultimedia.org/sparql-mm/functions/temporal#",
    "cbo": "http://comicmeta.org/cbo/",
    "bdd": "https://api.bloomberg.com/eap/catalogs/bbg/fields/",
    "kml": "http://www.opengis.net/kml/2.2#",
    "acrt": "http://privatealpha.com/ontology/certification/1#",
    "bgdbr": "http://bg.dbpedia.org/resource/",
    "onisep": "http://rdf.onisep.fr/resource/",
    "merge": "http://jazz.net/ns/lqe/merge/",
    "wfn": "http://webofcode.org/wfn/",
    "erce": "http://xxefe.de/",
    "olac": "http://www.language-archives.org/OLAC/1.0/",
    "company": "http://intellimind.io/ns/company#",
    "trig": "http://www.w3.org/2004/03/trix/rdfg-1/",
    "ruto": "http://rdfunit.aksw.org/ns/core#",
    "antenne": "https://data.zendantennes.omgeving.vlaanderen.be/ns/zendantenne#",
    "videogame": "http://purl.org/net/vgo#",
    "gts": "http://resource.geosciml.org/ontology/timescale/gts#",
    "sg": "http://www.springernature.com/scigraph/ontologies/core/",
    "samfl": "http://def.seegrid.csiro.au/ontology/om/sam-lite#",
    "bnf": "http://www.w3.org/2000/10/swap/grammar/bnf#",
    "swpm": "http://spi-fm.uca.es/spdef/models/deployment/swpm/1.0#",
    "pcdt": "http://purl.org/procurement/public-contracts-datatypes#",
    "voidext": "http://rdfs.org/ns/void-ext#",
    "ha": "http://sensormeasurement.appspot.com/ont/home/homeActivity#",
    "d0": "http://ontologydesignpatterns.org/ont/wikipedia/d0.owl#",
    "orth": "http://purl.org/net/orth#",
    "keys": "http://purl.org/NET/c4dm/keys.owl#",
    "mtlo": "http://www.ics.forth.gr/isl/MarineTLO/v4/marinetlo.owl#",
    "roadmap": "http://mappings.roadmap.org/",
    "oplres": "http://www.openlinksw.com/ontology/restrictions#",
    "bbccms": "http://www.bbc.co.uk/ontologies/cms/",
    "lcdr": "http://ns.lucid-project.org/revision/",
    "dicom": "http://purl.org/healthcarevocab/v1#",
    "dbrc": "http://dbpedia.org/resource/Category:",
    "esadm": "http://vocab.linkeddata.es/datosabiertos/def/sector-publico/territorio#",
    "itm": "http://spi-fm.uca.es/spdef/models/genericTools/itm/1.0#",
    "dsn": "http://purl.org/dsnotify/vocab/eventset/",
    "babelnet": "http://babelnet.org/2.0/",
    "bgdbp": "http://bg.dbpedia.org/property/",
    "incident": "http://vocab.resc.info/incident#",
    "property": "http://fr.dbpedia.org/property/",
    "rdaco": "http://rdaregistry.info/termList/RDAContentType/",
    "religion": "http://rdf.muninn-project.org/ontologies/religion#",
    "rdacc": "http://rdaregistry.info/termList/RDAColourContent/",
    "dio": "https://w3id.org/dio#",
    "eccrev": "https://vocab.eccenca.com/revision/",
    "ncit": "http://ncicb.nci.nih.gov/xml/owl/EVS/Thesaurus.owl#",
    "condition": "http://www.kinjal.com/condition:",
    "diag": "http://www.loc.gov/zing/srw/diagnostic/",
    "rdagrp": "http://rdaregistry.info/termList/groovePitch/",
    "ottr": "http://ns.ottr.xyz/templates#",
    "oplecrm": "http://www.openlinksw.com/ontology/ecrm#",
    "crowd": "http://purl.org/crowd/",
    "driver": "http://deductions.github.io/drivers.owl.ttl#",
    "cwrc": "http://sparql.cwrc.ca/ontology/cwrc#",
    "rdaftn": "http://rdaregistry.info/termList/TacNotation/",
    "bibrm": "http://vocab.ub.uni-leipzig.de/bibrm/",
    "gs1": "https://gs1.org/voc/",
    "jolux": "http://data.legilux.public.lu/resource/ontology/jolux#",
    "mod": "http://www.isibang.ac.in/ns/mod#",
    "step": "http://purl.org/net/step#",
    "rdact": "http://rdaregistry.info/termList/RDACarrierType/",
    "basic": "http://def.seegrid.csiro.au/isotc211/iso19103/2005/basic#",
    "rdatr": "http://rdaregistry.info/termList/typeRec/",
    "lfov": "https://w3id.org/legal_form#",
    "vag": "http://www.essepuntato.it/2013/10/vagueness/",
    "whisky": "http://vocab.org/whisky/terms/",
    "lsweb": "http://ontology.cybershare.utep.edu/ELSEWeb/elseweb-data.owl#",
    "dbug": "http://ontologi.es/doap-bugs#",
    "sakthi": "http://infotech.nitk.ac.in/research-scholars/sakthi-murugan-r/",
    "oplcb": "http://www.openlinksw.com/schemas/crunchbase#",
    "vstoi": "http://hadatac.org/ont/vstoi#",
    "ianarel": "https://www.w3.org/ns/iana/link-relations/relation#",
    "dash": "http://datashapes.org/dash#",
    "salad": "https://w3id.org/cwl/salad#",
    "rdag2": "http://rdvocab.info/ElementsGr2/",
    "olca": "http://www.lingvoj.org/olca#",
    "bbccore": "http://www.bbc.co.uk/ontologies/coreconcepts/",
    "rdarr": "http://rdaregistry.info/termList/RDAReductionRatio/",
    "odapps": "http://semweb.mmlab.be/ns/odapps#",
    "llm": "http://lodlaundromat.org/metrics/ontology/",
    "ontosec": "http://www.semanticweb.org/ontologies/2008/11/OntologySecurity.owl#",
    "proms": "http://promsns.org/def/proms#",
    "clirio": "http://clirio.kaerle.com/clirio.owl#",
    "oplacl": "http://www.openlinksw.com/ontology/acl#",
    "oae": "http://www.ics.forth.gr/isl/oae/core#",
    "odbc": "http://www.openlinksw.com/ontology/odbc#",
    "oplmkt": "http://www.openlinksw.com/ontology/market#",
    "im": "http://imgpedia.dcc.uchile.cl/resource/",
    "reegle": "http://reegle.info/schema#",
    "rut": "http://rdfunit.aksw.org/ns/core#",
    "td5": "http://td5.org/#",
    "kegg": "http://bio2rdf.org/ns/kegg#",
    "hdo": "http://www.samos.gr/ontologies/helpdeskOnto.owl#",
    "travel": "http://www.co-ode.org/roberts/travel.owl#",
    "doi": "https://doi.org/",
    "rofch": "http://rdaregistry.info/termList/rofch/",
    "omnfed": "http://open-multinet.info/ontology/omn-federation#",
    "puml": "http://plantuml.com/ontology#",
    "naval": "http://rdf.muninn-project.org/ontologies/naval#",
    "olac11": "http://www.language-archives.org/OLAC/1.1/",
    "glview": "http://schema.geolink.org/dev/view/",
    "uri4uri": "http://uri4uri.net/vocab#",
    "navm": "https://w3id.org/navigation_menu#",
    "rdarm": "http://registry.info/termList/recMedium/",
    "gci": "http://ontology.eil.utoronto.ca/GCI/Foundation/GCI-Foundation.owl#",
    "dossier": "https://data.omgeving.vlaanderen.be/ns/dossier#",
    "moo": "http://www.movieontology.org/2009/11/09/movieontology.owl#",
    "meat": "http://example.com/",
    "escom": "http://vocab.linkeddata.es/datosabiertos/def/comercio/tejidoComercial#",
    "espresup": "http://vocab.linkeddata.es/datosabiertos/def/hacienda/presupuestos#",
    "pp": "http://peoplesplaces.de/ontology#",
    "h2o": "http://def.seegrid.csiro.au/isotc211/iso19150/-2/2012/basic#",
    "jpo": "http://rdf.jpostdb.org/ontology/jpost.owl#",
    "oxi": "http://omerxi.com/ontologies/core.owl.ttl#",
    "rdafmn": "http://rdaregistry.info/termList/MusNotation/",
    "rdaemm": "http://rdaregistry.info/termList/emulsionMicro/",
    "koly": "http://www.ensias.ma/",
    "irsteaont": "http://ontology.irstea.fr/weather/ontology#",
    "demlab": "http://www.demcare.eu/ontologies/demlab.owl#",
    "hto": "http://project-haystack.org/hto#",
    "ubiq": "http://server.ubiqore.com/ubiq/core#",
    "lmx": "http://www.w3.org/XML/1998/namespace/",
    "vidont": "http://vidont.org/",
    "gpml": "http://vocabularies.wikipathways.org/gpml#",
    "rdabf": "http://rdaregistry.info/termList/bookFormat/",
    "lawd": "http://lawd.info/ontology/",
    "locah": "http://data.archiveshub.ac.uk/def/",
    "sirext": "http://t.me/sirextt/247:",
    "ev": "http://www.w3.org/2001/xml-events/",
    "tavprov": "http://ns.taverna.org.uk/2012/tavernaprov/",
    "caplibacl": "http://schemas.capita-libraries.co.uk/2015/acl/schema#",
    "lsqv": "http://lsq.aksw.org/vocab#",
    "teamwork": "http://topbraid.org/teamwork#",
    "uby": "http://purl.org/olia/ubyCat.owl#",
    "figigii": "http://www.omg.org/spec/FIGI/GlobalInstrumentIdentifiers/",
    "l2sp": "http://www.linked2safety-project.eu/properties/",
    "vsso": "http://automotive.eurecom.fr/vsso#",
    "text": "http://jena.apache.org/text#",
    "rvl": "http://purl.org/rvl/",
    "ecglview": "http://schema.geolink.org/view/",
    "ns1": "http://www.w3.org/1999/xhtml/vocab#",
    "newsevents": "http://www.aifb.uni-karlsruhe.de/WBS/uhe/ontologies#",
    "zr": "http://explain.z3950.org/dtd/2.0/",
    "lslife": "http://ontology.cybershare.utep.edu/ELSEWeb/elseweb-lifemapper.owl#",
    "rdasco": "http://rdaregistry.info/termList/soundCont/",
    "hello": "https://www.youtube.com/user/SuperTellAFriend/featured/",
    "cwl": "https://w3id.org/cwl/cwl#",
    "airs": "https://raw.githubusercontent.com/airs-linked-data/lov/latest/src/airs_vocabulary.ttl#",
    "dicera": "http://semweb.mmlab.be/ns/dicera#",
    "metadata": "http://purl.oreilly.com/ns/meta/",
    "traffic": "http://www.sensormeasurement.appspot.com/ont/transport/traffic#",
    "fp3": "http://vocab.fusepool.info/fp3#",
    "bb": "http://www.snik.eu/ontology/bb/",
    "efrbroo": "http://erlangen-crm.org/efrbroo/",
    "geovoid": "http://purl.org/geovocamp/ontology/geovoid/",
    "rdafs": "http://rdaregistry.info/termList/fontSize/",
    "rdapmt": "http://rdaregistry.info/termList/prodTactile/",
    "rofer": "http://rdaregistry.info/termList/rofer/",
    "mmo": "http://purl.org/momayo/mmo/",
    "jerm": "http://jermontology.org/ontology/JERMOntology#",
    "mexv": "http://mex.aksw.org/mex-algo#",
    "lemonuby": "http://lemon-model.net/lexica/uby/",
    "agr": "http://promsns.org/def/agr#",
    "aktivesa": "http://sa.aktivespace.org/ontologies/aktivesa#",
    "sx": "http://shex.io/ns/shex#",
    "rdaz": "http://rdaregistry.info/Elements/z/",
    "bioc": "http://deductions.github.io/biological-collections.owl.ttl#",
    "mdi": "http://w3id.org/multidimensional-interface/ontology#",
    "ws": "http://www.w3.org/ns/pim/space#",
    "cpack": "http://cliopatria.swi-prolog.org/schema/cpack#",
    "iana": "http://www.iana.org/assignments/relation/",
    "owsom": "https://onlinesocialmeasures.wordpress.com/",
    "regorg": "http://www.w3.org/ns/regorg#",
    "ssno": "http://www.w3.org/ns/ssn/",
    "irstea": "http://ontology.irstea.fr/",
    "spcm": "http://spi-fm.uca.es/spdef/models/deployment/spcm/1.0#",
    "year": "http://www.w3.org/year/",
    "esapar": "http://vocab.linkeddata.es/datosabiertos/def/urbanismo-infraestructuras/aparcamiento#",
    "hasneto": "http://hadatac.org/ont/hasneto#",
    "fdbp": "http://fr.dbpedia.org/property/",
    "cd": "http://citydata.wu.ac.at/ns#",
    "yd": "https://yodata.io/",
    "uneskos": "http://purl.org/voc/uneskos#",
    "tix": "http://toptix.com/2010/esro/",
    "fire": "http://tldp.org/HOWTO/XML-RPC-HOWTO/xmlrpc-howto-java.html#",
    "lmf": "http://www.lexinfo.net/lmf#",
    "bsym": "http://bsym.bloomberg.com/sym/",
    "webservice": "http://www.openlinksw.com/ontology/webservices#",
    "lheo": "http://www.conjecto.com/ontology/2015/lheo#",
    "ruian": "https://data.cssz.cz/ontology/ruian/",
    "xslopm": "http://purl.org/net/opmv/types/xslt#",
    "gont": "https://gont.ch/",
    "ofrd": "http://purl.org/opdm/refrigerator#",
    "essglobal": "http://purl.org/essglobal/vocab/v1.0/",
    "tadirah": "http://tadirah.dariah.eu/vocab/",
    "ilap": "http://data.posccaesar.org/ilap/",
    "eccauth": "https://vocab.eccenca.com/auth/",
    "vartrans": "http://www.w3.org/ns/lemon/vartrans#",
    "nlon": "http://lod.nl.go.kr/ontology/",
    "rdaterm": "http://rdaregistry.info/termList/RDATerms/",
    "ttp": "http://eample.com/test#",
    "obeu": "http://data.openbudgets.eu/ontology/",
    "sto": "https://w3id.org/i40/sto#",
    "sdshare": "http://www.sdshare.org/2012/extension/",
    "datex": "http://vocab.datex.org/terms#",
    "lswmo": "http://ontology.cybershare.utep.edu/ELSEWeb/elseweb-modelling.owl#",
    "ndnp": "http://chroniclingamerica.loc.gov/terms#",
    "mexcore": "http://mex.aksw.org/mex-core#",
    "rofrr": "http://rdaregistry.info/termList/rofrr/",
    "bot": "https://w3id.org/bot#",
    "ou": "http://opendata.unex.es/def/ontouniversidad#",
    "rofem": "http://rdaregistry.info/termList/rofem/",
    "fntbox": "http://www.ontologydesignpatterns.org/ont/framenet/tbox/",
    "crime": "http://purl.org/vocab/reloc/",
    "sgg": "http://www.springernature.com/scigraph/graphs/",
    "escjr": "http://vocab.linkeddata.es/datosabiertos/def/urbanismo-infraestructuras/callejero#",
    "door": "http://kannel.open.ac.uk/ontology#",
    "estatwrap": "http://ontologycentral.com/2009/01/eurostat/ns#",
    "fnabox": "http://www.ontologydesignpatterns.org/ont/framenet/abox/",
    "swo": "http://www.ebi.ac.uk/swo/",
    "owl2xml": "http://www.w3.org/2006/12/owl2-xml#",
    "lswpm": "http://ontology.cybershare.utep.edu/ELSEWeb/elseweb-lifemapper-parameters.owl#",
    "loted": "http://loted.eu/ontology#",
    "output": "http://volt-name.space/vocab/output#",
    "oplweb": "http://www.openlinksw.com/schemas/oplweb#",
    "literal": "http://www.essepuntato.it/2010/06/literalreification/",
    "mbgd": "http://mbgd.genome.ad.jp/owl/mbgd.owl#",
    "wn30": "http://purl.org/vocabularies/princeton/wn30/",
    "ttla": "https://w3id.org/ttla/",
    "tsn": "http://purl.org/net/tsn#",
    "mls": "http://www.w3.org/ns/mls#",
    "pid": "http://permid.org/ontology/organization/",
    "pv": "http://ns.inria.fr/provoc#",
    "lgdm": "http://linkedgeodata.org/meta/",
    "rofit": "http://rdaregistry.info/termList/rofit/",
    "vacseen1": "http://www.semanticweb.org/parthasb/ontologies/2014/6/vacseen1/",
    "hva": "http://www.ebusiness-unibw.org/ontologies/hva/ontology#",
    "waarde": "https://lod.milieuinfo.be/ns/waarde#",
    "voc": "http://voc.odw.tw/",
    "um": "http://intelleo.eu/ontologies/user-model/ns/",
    "soch": "http://kulturarvsdata.se/ksamsok#",
    "open311": "http://ontology.eil.utoronto.ca/open311#",
    "gns": "http://sws.geonames.org/",
    "unspsc": "http://ontoview.org/schema/unspsc/1#",
    "markus": "http://www.markus.com/",
    "alethio": "http://aleth.io/",
    "ensembl": "http://rdf.ebi.ac.uk/resource/ensembl/",
    "pmhb": "http://pmhb.org/",
    "task": "http://deductions.github.io/task-management.owl.ttl#",
    "wde": "http://www.wikidata.org/entity/",
    "crml": "http://semweb.mmlab.be/ns/rml/condition#",
    "rdafnv": "http://rdaregistry.info/termList/noteForm/",
    "aprov": "http://purl.org/a-proc#",
    "pmc": "http://identifiers.org/pmc/",
    "dm2e": "http://onto.dm2e.eu/schemas/dm2e/",
    "rofsm": "http://rdaregistry.info/termList/rofsm/",
    "uom": "http://www.opengis.net/def/uom/OGC/1.0/",
    "voidwh": "http://www.ics.forth.gr/isl/VoIDWarehouse/VoID_Extension_Schema.owl#",
    "scco": "http://rdf.ebi.ac.uk/terms/surechembl#",
    "gg": "http://www.gemeentegeschiedenis.nl/gg-schema#",
    "ifc": "http://ifcowl.openbimstandards.org/IFC2X3_Final#",
    "piero": "http://reactionontology.org/piero/",
    "jpost": "http://rdf.jpostdb.org/ontology/jpost.owl#",
    "opllog": "http://www.openlinksw.com/ontology/logging#",
    "si": "http://sisteminformasi.com/",
    "geojson": "http://ld.geojson.org/vocab#",
    "eccdi": "https://vocab.eccenca.com/di/",
    "ethc": "http://ethoinformatics.org/ethocore/",
    "wimpo": "http://rdfex.org/withImports?uri=",
    "pmo": "http://premon.fbk.eu/ontology/core#",
    "lgt": "http://linkedgadget.com/wiki/Property:",
    "amsl": "http://vocab.ub.uni-leipzig.de/amsl/",
    "frgeo": "http://rdf.insee.fr/geo/",
    "nobel": "http://data.nobelprize.org/terms/",
    "sdt": "http://statisticaldata.linkedwidgets.org/terms/",
    "memento": "http://mementoweb.org/ns#",
    "wikimedia": "http://upload.wikimedia.org/wikipedia/commons/f/f6/",
    "dao": "http://purl.org/dao#",
    "planet": "http://dbpedia.org/",
    "mmoon": "http://mmoon.org/mmoon/",
    "llont": "http://www.linklion.org/ontology#",
    "esair": "http://vocab.linkeddata.es/datosabiertos/def/medio-ambiente/calidad-aire#",
    "imind": "http://schema.intellimind.ns/symbology#",
    "rdapm": "http://rdaregistry.info/termList/RDAproductionMethod/",
    "b3kat": "http://lod.b3kat.de/title/",
    "biml": "http://schemas.varigence.com/biml.xsd#",
    "tgm": "http://id.loc.gov/vocabulary/graphicMaterials/",
    "dpn": "http://purl.org/dpn#",
    "webac": "http://fedora.info/definitions/v4/webac#",
    "duv": "http://www.w3.org/ns/duv#",
    "glycan": "http://purl.jp/bio/12/glyco/glycan#",
    "rdaar": "http://rdaregistry.info/termList/AspectRatio/",
    "meeting": "http://www.w3.org/2002/07/meeting#",
    "tg": "https://triplydb.com/Triply/tg/def/",
    "vam": "http://www.metmuseum.org/",
    "tui": "http://data.ifs.tuwien.ac.at/study/resource/",
    "customer": "http://www.valuelabs.com/",
    "itcat": "http://th-brandenburg.de/ns/itcat#",
    "ecoll": "http://purl.org/ceu/eco/1.0#",
    "s4envi": "https://w3id.org/def/saref4envi#",
    "adr": "https://w3id.org/laas-iot/adream#",
    "studiop": "http://purl.org/resource/pilatesstudio/",
    "pdf": "http://ns.adobe.com/pdf/1.3/",
    "rofrm": "http://rdaregistry.info/termList/rofrm/",
    "tarql": "http://tarql.github.io/tarql#",
    "huto": "http://ns.inria.fr/huto/",
    "system": "http://www.univalle.edu.co/ontologies/System#",
    "cwork": "http://www.bbc.co.uk/ontologies/creativework/",
    "pmd": "http://publishmydata.com/def/dataset#",
    "tx": "http://swtmp.gitlab.io/vocabulary/templates.owl#",
    "umls": "http://bioportal.bioontology.org/ontologies/umls/",
    "meshv": "http://id.nlm.nih.gov/mesh/vocab#",
    "eame": "http://www.semanticweb.org/ontologia_EA#",
    "pcit": "http://public-contracts.nexacenter.org/id/propertiesRole/",
    "rdacarx": "http://rdaregistry.info/termList/RDACarrierEU/",
    "mexalgo": "http://mex.aksw.org/mex-algo#",
    "lyon": "http://dbpedia.org/resource/Lyon/",
    "fuseki": "http://jena.apache.org/fuseki#",
    "cue": "http://www.clarin.eu/cmdi/cues/display/1.0#",
    "minim": "http://purl.org/minim/minim#",
    "ago": "http://awesemantic-geo.link/ontology/",
    "bl": "https://w3id.org/biolink/vocab/",
    "rofid": "http://rdaregistry.info/termList/rofid/",
    "edgarcik": "http://edgarwrap.ontologycentral.com/cik/",
    "neotec": "http://neotec.rc.unesp.br/resource/Neotectonics/",
    "fr": "https://w3id.org/fr/def/core#",
    "smxm": "http://smxm.ga/",
    "ldl": "https://w3id.org/ldpdl/ns#",
    "organ": "http://www.univalle.edu.co/ontologies/Organ#",
    "bgt": "https://bgt.basisregistraties.overheid.nl/bgt/def/",
    "vogd": "http://ogd.ifs.tuwien.ac.at/vienna/geo/",
    "rdalay": "http://rdaregistry.info/termList/layout/",
    "rpath": "https://w3id.org/lodsight/rdf-path#",
    "iiif": "http://iiif.io/api/image/2#",
    "rgml": "http://purl.org/puninj/2001/05/rgml-schema#",
    "rdaft": "http://rdaregistry.info/termList/fileType/",
    "composer": "http://dbpedia.org/ontology/composer/",
    "alice": "http://example.org/",
    "ioto": "http://www.irit.fr/recherches/MELODI/ontologies/IoT-O#",
    "bdc": "http://dbpedia.org/resource/Category:",
    "kbv": "https://id.kb.se/vocab/",
    "scholl": "http://menemeneml.com/school#",
    "mmm": "http://www.mico-project.eu/ns/mmm/2.0/schema#",
    "vocnet": "http://schema.vocnet.org/",
    "qms": "http://data.europa.eu/esco/qms#",
    "pato": "http://purl.obolibrary.org/obo/",
    "ipsv": "http://id.esd.org.uk/list/",
    "semiot": "http://w3id.org/semiot/ontologies/semiot#",
    "eol": "http://purl.org/biodiversity/eol/",
    "apf": "http://jena.apache.org/ARQ/property#",
    "remetca": "http://www.purl.org/net/remetca#",
    "ali": "http://www.niso.org/schemas/ali/1.0/",
    "eem": "http://purl.org/eem#",
    "lsq": "http://lsq.aksw.org/vocab#",
    "opa": "https://w3id.org/laas-iot/adream#",
    "rdaspc": "http://rdaregistry.info/termList/specPlayback/",
    "dataid": "http://dataid.dbpedia.org/ns/core#",
    "ncicp": "http://ncicb.nci.nih.gov/xml/owl/EVS/Thesaurus.owl#",
    "doacc": "http://purl.org/net/bel-epa/doacc#",
    "dcosample": "http://info.deepcarbon.net/sample/schema#",
    "dwciri": "http://rs.tdwg.org/dwc/iri/",
    "swcomp": "https://github.com/ali1k/ld-reactor/blob/master/vocabulary/index.ttl#",
    "gt": "https://vocab.eccenca.com/geniustex/",
    "dsw": "http://purl.org/dsw/",
    "nature": "http://deductions.github.io/nature_observation.owl.ttl#",
    "cff": "http://purl.oclc.org/NET/ssnx/cf/cf-feature#",
    "juso": "http://rdfs.co/juso/",
    "lgdt": "http://linkedgeodata.org/triplify/",
    "yso": "http://www.yso.fi/onto/yso/",
    "or": "http://openresearch.org/vocab/",
    "activity": "https://www.w3.org/TR/activitystreams-vocabulary/",
    "sdmxm": "http://purl.org/linked-data/sdmx/2009/measure#",
    "sorg": "http://schema.org/",
    "cpov": "http://data.europa.eu/m8g/",
    "pmovn": "http://premon.fbk.eu/ontology/vn#",
    "pmonb": "http://premon.fbk.eu/ontology/nb#",
    "bblfish": "http://bblfish.net/people/henry/card#",
    "csdbp": "http://cs.dbpedia.org/",
    "rofin": "http://rdaregistry.info/termList/rofin/",
    "svcs": "http://rdfs.org/sioc/services#",
    "dbfo": "http://dbpedia.org/facts/ontology#",
    "maet": "http://edg.topbraid.solutions/taxonomy/macroeconomics/",
    "datacite": "http://purl.org/spar/datacite/",
    "volt": "http://volt-name.space/ontology/",
    "vplan": "http://www.ifs.tuwien.ac.at/~miksa/ontologies/VPlan.owl#",
    "pm": "http://premon.fbk.eu/resource/",
    "amt": "http://academic-meta-tool.xyz/vocab#",
    "seokoeln": "http://rankrage.de/",
    "isbdu": "http://iflastandards.info/ns/isbd/unc/elements/",
    "add": "http://www.datatourisme.fr/ontology/core/1.0#",
    "rofrt": "http://rdaregistry.info/termList/rofrt/",
    "spv": "http://completeness.inf.unibz.it/sp-vocab#",
    "pmofn": "http://premon.fbk.eu/ontology/fn#",
    "pep": "https://w3id.org/pep/",
    "wdv": "http://www.wikidata.org/value/",
    "rdapf": "http://rdaregistry.info/termList/presFormat/",
    "ids": "https://w3id.org/idsa/core/",
    "dsfv": "http://sws.ifi.uio.no/vocab/dsf/henriwi/dsf#",
    "audit": "http://fedora.info/definitions/v4/audit#",
    "sct": "http://snomed.info/id/",
    "rofsf": "http://rdaregistry.info/termList/rofsf/",
    "owms": "http://standaarden.overheid.nl/owms/terms/",
    "wail": "http://www.eyrie.org/~zednenem/2002/wail/",
    "rdfp": "https://w3id.org/rdfp/",
    "imo": "http://imgpedia.dcc.uchile.cl/ontology#",
    "oplwebsrv": "http://www.openlinksw.com/ontology/webservices#",
    "dk": "http://www.data-knowledge.org/dk/schema/rdf/latest/",
    "km4c": "http://www.disit.org/km4city/schema#",
    "dcodt": "http://info.deepcarbon.net/datatype/schema#",
    "uc": "http://ucuenca.edu.ec/ontology#",
    "brt": "http://brt.basisregistraties.overheid.nl/def/top10nl#",
    "rdax": "http://rdaregistry.info/Elements/x/",
    "ver": "https://w3id.org/version/ontology#",
    "esproc": "http://vocab.linkeddata.es/datosabiertos/def/sector-publico/procedimientos#",
    "voidex": "http://www.swi-prolog.org/rdf/library/",
    "sdmxcode": "http://purl.org/linked-data/sdmx/2009/code#",
    "clapit": "http://dati.gov.it/onto/clapit/",
    "rofhf": "http://rdaregistry.info/termList/rofhf/",
    "dcap": "http://purl.org/ws-mmi-dc/terms/",
    "tissue": "http://www.univalle.edu.co/ontologies/Tissue#",
    "pbody": "http://reference.data.gov.uk/def/public-body/",
    "pcdm": "http://pcdm.org/models#",
    "llr": "http://lodlaundromat.org/resource/",
    "gobierno": "http://www.gobierno.es/gobierno/",
    "ppr": "http://purl.org/datanode/ppr/ns/",
    "changeset": "http://purl.org/vocab/changeset/schema#",
    "asawoo": "http://liris.cnrs.fr/asawoo/",
    "rdagen": "http://rdaregistry.info/termList/RDAGeneration/",
    "geoloc": "http://deductions.github.io/geoloc.owl.ttl#",
    "elod": "http://linkedeconomy.org/ontology#",
    "sdterms": "http://statisticaldata.linkedwidgets.org/terms/",
    "srx": "http://www.w3.org/2005/sparql-results#",
    "provinsi": "http://provinsi.com/",
    "seeds": "http://deductions.github.io/seeds.owl.ttl#",
    "id": "http://identifiers.org/",
    "maeco": "http://edg.topbraid.solutions/maeco/",
    "frappe": "http://streamreasoning.org/ontologies/frappe#",
    "dto": "http://www.datatourisme.fr/ontology/core/1.0#",
    "ppn": "http://parliament.uk/ontologies/person-name/",
    "undata": "http://citydata.wu.ac.at/Linked-UNData/data/",
    "nkos": "http://w3id.org/nkos#",
    "sgiter": "http://w3id.org/sparql-generate/iter/",
    "dcodata": "http://info.deepcarbon.net/data/schema#",
    "rdacdt": "http://rdaregistry.info/termList/RDACartoDT/",
    "provoc": "http://ns.inria.fr/provoc/",
    "aozora": "http://purl.org/net/aozora/",
    "ja": "http://jena.hpl.hp.com/2005/11/Assembler#",
    "isidore": "http://www.rechercheisidore.fr/class/",
    "pand": "http://bag.basisregistraties.overheid.nl/bag/id/pand/",
    "assoc": "https://w3id.org/associations/vocab#",
    "rofim": "http://rdaregistry.info/termList/rofim/",
    "gdc": "https://portal.gdc.cancer.gov/cases/",
    "fluidops": "http://www.fluidops.com/",
    "ldqm": "http://linkeddata.es/resource/ldqm/",
    "dcx": "http://dublincore.org/dcx/",
    "it": "http://www.influencetracker.com/ontology#",
    "oplbenefit": "http://www.openlinksw.com/ontology/benefits#",
    "edac": "http://ontology.cybershare.utep.edu/ELSEWeb/elseweb-edac.owl#",
    "its": "http://www.w3.org/2005/11/its/rdf#",
    "tosh": "http://topbraid.org/tosh#",
    "ispra": "http://dati.isprambiente.it/ontology/core#",
    "ceterms": "http://purl.org/ctdl/terms/",
    "rm": "http://jazz.net/ns/rm#",
    "marcrole": "http://id.loc.gov/vocabulary/relators/",
    "rdabs": "http://rdaregistry.info/termList/broadcastStand/",
    "brk": "http://brk.basisregistraties.overheid.nl/def/brk#",
    "oplli": "http://www.openlinksw.com/schemas/linkedin#",
    "connard": "https://mail.google.com/mail/u/1/#",
    "rdacpc": "http://rdaregistry.info/termList/configPlayback/",
    "sgfn": "http://w3id.org/sparql-generate/fn/",
    "sfn": "http://semweb.datasciencelab.be/ns/sfn#",
    "sdmxc": "http://purl.org/linked-data/sdmx/2009/concept#",
    "wsdl": "http://www.w3.org/ns/wsdl-rdf#",
    "ctxdesc": "http://www.demcare.eu/ontologies/contextdescriptor.owl#",
    "bdo": "http://purl.bdrc.io/ontology/core/",
    "efd": "http://data.foodanddrinkeurope.eu/ontology#",
    "emergelm": "http://purl.org/emergel/modules#",
    "fun": "http://w3id.org/sparql-generate/fn/",
    "qbe": "http://citydata.wu.ac.at/qb-equations#",
    "eccpubsub": "https://vocab.eccenca.com/pubsub/",
    "rdaill": "http://rdaregistry.info/termList/IllusContent/",
    "gvoith": "http://assemblee-virtuelle.github.io/grands-voisins-v2/thesaurus.ttl#",
    "orcid": "http://orcid.org/",
    "pmopb": "http://premon.fbk.eu/ontology/pb#",
    "persee": "http://data.persee.fr/ontology/persee_ontology/",
    "ns2": "http://ogp.me/ns#video:",
    "r4r": "http://guava.iis.sinica.edu.tw/r4r/",
    "master1": "http://idl.u-grenoble3.fr/",
    "neotecbib": "http://neotec.rc.unesp.br/resource/NeotectonicsBibliography/",
    "lido": "http://www.lido-schema.org/",
    "ldq": "http://www.linkeddata.es/ontology/ldq#",
    "rfd": "http://com.intrinsec//ontology#",
    "foam": "https://www.koerperfettwaage-test.de/",
    "cocoon": "https://w3id.org/cocoon/v1.0#",
    "rdaad": "http://rdaregistry.info/Elements/a/datatype/",
    "bds": "http://www.bigdata.com/rdf/search#",
    "ims": "http://www.imsglobal.org/xsd/imsmd_v1p2/",
    "geor": "http://www.opengis.net/def/rule/geosparql/",
    "vort": "http://rockets.topbraid.solutions/vort/",
    "iso37120": "http://ontology.eil.utoronto.ca/ISO37120.owl#",
    "ldn": "https://www.w3.org/TR/ldn/#",
    "wab": "http://wab.uib.no/cost-a32_philospace/wittgenstein.owl#",
    "lmdb": "http://data.linkedmdb.org/movie/",
    "ido": "http://purl.obolibrary.org/obo/ido.owl#",
    "d3s": "http://vocbench.solidaridad.cloud/taxonomies#",
    "fog": "https://w3id.org/fog#",
    "psv": "http://www.wikidata.org/prop/statement/value/",
    "rofet": "http://rdaregistry.info/termList/rofet/",
    "pair": "http://virtual-assembly.org/pair/PAIR_LOD_V3.owl/",
    "sylld": "http://www.semanticweb.org/syllabus/data/",
    "sirene": "https://sireneld.io/vocab/sirene#",
    "sciprov": "http://sweetontology.net/reprSciProvenance/",
    "plg": "http://parliament.uk/ontologies/legislation/",
    "aml": "https://w3id.org/i40/aml#",
    "logies": "https://data.vlaanderen.be/ns/logies#",
    "dsv": "http://purl.org/iso25964/DataSet/Versioning#",
    "pop": "http://wiki.dbpedia.org/",
    "agrovoc": "http://aims.fao.org/aos/agrovoc/",
    "oplp": "http://www.openlinksw.com/ontology/purchases#",
    "ncbigene": "http://identifiers.org/ncbigene/",
    "da": "https://www.wowman.org/index.php?id=1&type=get#",
    "fhir": "http://hl7.org/fhir/",
    "eustd": "http://eurostat.linked-statistics.org/data#",
    "w3cgeo": "http://www.w3.org/2003/01/geo/wgs84_pos#",
    "ideotalex": "http://www.ideotalex.eu/datos/recurso/",
    "llalg": "http://www.linklion.org/algorithm/",
    "oplstocks": "http://www.openlinksw.com/ontology/stocks#",
    "vehma": "http://deductions.github.io/vehicule-management.owl.ttl#",
    "iter": "http://w3id.org/sparql-generate/iter/",
    "emergel": "http://purl.org/emergel/core#",
    "vsearch": "http://vocab.sti2.at/vsearch#",
    "osd": "http://a9.com/-/spec/opensearch/1.1/",
    "edg": "http://edg.topbraid.solutions/model/",
    "nih": "http://ncicb.nci.nih.gov/xml/owl/EVS/Thesaurus.owl#",
    "cpi": "http://www.ebusiness-unibw.org/ontologies/cpi/ns#",
    "prof": "http://www.w3.org/ns/dx/prof/",
    "globalcube": "http://kalmar32.fzi.de/triples/global-cube.ttl#",
    "lmo": "http://linkedmultimedia.org/sparql-mm/ns/2.0.0/ontology#",
    "ifcowl": "http://www.buildingsmart-tech.org/ifcOWL/IFC4_ADD2#",
    "shui": "https://vocab.eccenca.com/shui/",
    "rdavf": "http://rdaregistry.info/termList/videoFormat/",
    "rdare": "http://rdaregistry.info/termList/RDARegionalEncoding/",
    "ecore": "http://www.eclipse.org/emf/2002/Ecore#",
    "odw": "http://odw.tw/",
    "sfd": "http://semantic-forms.cc:9112/ldp/",
    "estatgph": "http://estatwrap.ontologycentral.com/id/nama_aux_gph#",
    "prohow": "https://w3id.org/prohow#",
    "besluit": "http://data.vlaanderen.be/ns/besluit#",
    "cdao": "http://purl.obolibrary.org/obo/",
    "aseonto": "http://requirement.ase.ru/requirements_ontology#",
    "input": "http://volt-name.space/vocab/input#",
    "radar": "http://www.radar-projekt.org/display/",
    "ondc": "http://www.semanticweb.org/ontologies/2012/1/Ontology1329913965202.owl#",
    "bob": "http://good.dad/meaning/bob#",
    "ontop": "https://w3id.org/ontop/",
    "gvoi": "http://assemblee-virtuelle.github.io/grands-voisins-v2/gv.owl.ttl#",
    "cubeont": "http://ontology.cube.global/",
    "decprov": "http://promsns.org/def/decprov#",
    "scra": "http://purl.org/net/schemarama#",
    "dcatnl": "http://standaarden.overheid.nl/dcatnl/terms/",
    "mml": "http://www.w3.org/1998/Math/MathML/",
    "orgesv2": "http://datos.gob.es/sites/default/files/OntologiaDIR3/orges.owl#",
    "brick": "https://brickschema.org/schema/1.1/Brick#",
    "dqc": "http://semwebquality.org/ontologies/dq-constraints#",
    "numbers": "http://km.aifb.kit.edu/projects/numbers/",
    "ogdl4m": "https://github.com/martynui/OGDL4M/",
    "afr": "http://purl.allotrope.org/ontologies/result#",
    "genre": "http://sparql.cwrc.ca/ontologies/genre#",
    "halyard": "http://merck.github.io/Halyard/ns#",
    "mexperf": "http://mex.aksw.org/mex-perf#",
    "oplangel": "http://www.openlinksw.com/schemas/angel#",
    "tsnchange": "http://purl.org/net/tsnchange#",
    "rimmf": "http://rimmf.com/vocab/",
    "dead": "http://utpl.edu.ec/sbc/data/",
    "docker": "http://www.w3.org/ns/bde/docker/",
    "hico": "http://purl.org/emmedi/hico/",
    "s3n": "http://w3id.org/s3n/",
    "mandaat": "http://data.vlaanderen.be/ns/mandaat#",
    "estrf": "http://vocab.linkeddata.es/datosabiertos/def/transporte/trafico#",
    "dot": "https://w3id.org/dot#",
    "dgfr": "http://colin.maudry.com/ontologies/dgfr#",
    "lcsh": "http://id.loc.gov/authorities/subjects/",
    "bdr": "http://purl.bdrc.io/resource/",
    "fssp": "http://linkeddata.fssprus.ru/resource/",
    "led": "http://led.kmi.open.ac.uk/term/",
    "ln": "https://w3id.org/ln#",
    "bci": "https://w3id.org/BCI-ontology#",
    "imas": "https://sparql.crssnky.xyz/imasrdf/URIs/imas-schema.ttl#",
    "datacron": "http://www.datacron-project.eu/datAcron#",
    "gbol": "http://gbol.life/0.1#",
    "fnml": "http://semweb.mmlab.be/ns/fnml#",
    "number": "http://km.aifb.kit.edu/projects/numbers/number#",
    "valueflows": "https://w3id.org/valueflows/",
    "rvz": "http://rdfvizler.dyreriket.xyz/vocabulary/core#",
    "lovc": "https://w3id.org/lovcube/ns/lovcube#",
    "mobivoc": "http://schema.mobivoc.org/",
    "cim": "http://iec.ch/TC57/2013/CIM-schema-cim16#",
    "iotlite": "http://purl.oclc.org/NET/UNIS/fiware/iot-lite#",
    "r3d": "http://www.re3data.org/schema/3-0#",
    "omg": "https://w3id.org/omg#",
    "seo": "http://sda.tech/SEOontology/SEO/",
    "geo7": "https://www.geo7.ch/",
    "eepsa": "https://w3id.org/eepsa#",
    "dpla": "http://dp.la/info/developers/map/",
    "cwlprov": "https://w3id.org/cwl/prov#",
    "nrv": "http://ns.inria.fr/nrv#",
    "yaco": "https://www.irit.fr/recherches/MELODI/ontologies/cinema#",
    "munc": "http://ns.inria.fr/munc#",
    "fred": "http://www.ontologydesignpatterns.org/ont/fred/domain.owl#",
    "roar": "https://w3id.org/roar#",
    "theme": "http://voc.odw.tw/theme/",
    "rls": "https://w3id.org/lovcube/ns/relovstats#",
    "conference": "https://w3id.org/scholarlydata/ontology/conference-ontology.owl#",
    "pfeepsa": "https://w3id.org/pfeepsa#",
    "ldt": "https://www.w3.org/ns/ldt#",
    "faostat": "http://reference.eionet.europa.eu/faostat/schema/",
    "ddb": "http://www.deutsche-digitale-bibliothek.de/edm/",
    "iab": "https://www.iab.com/guidelines/taxonomy/",
    "cbim": "http://www.coinsweb.nl/cbim-2.0.rdf#",
    "iati": "http://purl.org/collections/iati/",
    "literature": "http://purl.org/net/cnyt-literature#",
    "gdpr": "https://vocab.eccenca.com/gdpr/",
    "s4bldg": "https://w3id.org/def/saref4bldg#",
    "isaterms": "http://purl.org/isaterms/",
    "nosql": "http://purl.org/db/nosql#",
    "lmu": "https://w3id.org/laas-iot/lmu#",
    "ecowlim": "http://ecowlim.tfri.gov.tw/lode/resource/",
    "conll": "http://ufal.mff.cuni.cz/conll2009-st/task-description.html#",
    "loupe": "http://ont-loupe.linkeddata.es/def/core/",
    "vir": "http://w3id.org/vir#",
    "az": "https://w3id.org/people/az/",
    "scho": "http://www.scholarlydata.org/ontology/conference-ontology.owl#",
    "bioentity": "http://bioentity.io/vocab/",
    "snac": "http://socialarchive.iath.virginia.edu/",
    "legal": "http://www.w3.org/ns/legal#",
    "mdont": "http://ont.matchdeck.com/",
    "timex": "http://data.wu.ac.at/ns/timex#",
    "mydb": "http://mydb.org/",
    "linkrel": "https://www.w3.org/ns/iana/link-relations/relation#",
    "dnbt": "http://d-nb.info/standards/elementset/dnb#",
    "adf": "http://purl.allotrope.org/ontologies/datapackage#",
    "atlasterms": "http://rdf.ebi.ac.uk/terms/atlas/",
    "mwapi": "https://www.mediawiki.org/ontology#API/",
    "cwlgit": "https://w3id.org/cwl/view/git/",
    "m3": "http://sensormeasurement.appspot.com/m3#",
    "foaffff": "http://gogl.com/",
    "drk": "http://drakon.su/",
    "bpo": "https://w3id.org/bpo#",
    "esservicio": "http://vocab.linkeddata.es/datosabiertos/def/sector-publico/servicio#",
    "url": "http://schema.org/",
    "aksw": "http://aksw.org/",
    "smartapi": "http://smart-api.io/ontology/1.0/smartapi#",
    "medred": "http://w3id.org/medred/medred#",
    "physics": "http://www.astro.umd.edu/~eshaya/astro-onto/owl/physics.owl#",
    "swrc2": "https://www.cs.vu.nl/~mcaklein/onto/swrc_ext/2005/05#",
    "summa": "http://purl.org/voc/summa/",
    "beer": "http://beer.com/",
    "afm": "http://purl.allotrope.org/ontologies/material/",
    "county": "http://myexample.org/county#",
    "vehman": "http://deductions.github.io/vehicule-management.owl.ttl#",
    "swa": "http://topbraid.org/swa#",
    "kmgeo": "http://km.aifb.kit.edu/services/geo/ontology#",
    "one": "https://bioportal.bioontology.org/ontologies/ONE/",
    "ctrl": "https://w3id.org/ibp/CTRLont#",
    "reg": "http://purl.org/linked-data/registry#",
    "dpv": "http://www.w3.org/ns/dpv#",
    "chear": "http://hadatac.org/ont/chear#",
    "ca": "http://complyadvantage.com/",
    "vss": "http://automotive.eurecom.fr/vsso#",
    "alg": "http://drakon.su/ADF#",
    "mem": "http://mementoweb.org/ns#",
    "nno": "https://w3id.org/nno/ontology#",
    "refexo": "http://purl.jp/bio/01/refexo#",
    "odf": "http://docs.oasis-open.org/ns/office/1.2/meta/odf#",
    "fnom": "https://w3id.org/function/vocabulary/mapping#",
    "ucum": "http://purl.oclc.org/NET/muo/ucum/",
    "devuan": "https://devuan.net.br/",
    "idot": "http://identifiers.org/idot/",
    "pcdmuse": "http://pcdm.org/use#",
    "ul": "http://underlay.mit.edu/ns/",
    "ontoneo": "http://purl.obolibrary.org/obo/ontoneo/",
    "edr": "https://w3id.org/laas-iot/edr#",
    "bkb": "https://budayakb.cs.ui.ac.id/ns#",
    "frbroo": "http://iflastandards.info/ns/fr/frbr/frbroo/",
    "semsur": "http://purl.org/SemSur/",
    "tb": "https://w3id.org/timebank#",
    "trao": "http://linkeddata.finki.ukim.mk/lod/ontology/tao#",
    "roc": "https://w3id.org/ro/curate#",
    "tikag": "https://www.tikag.com/",
    "crmeh": "http://purl.org/crmeh#",
    "sohukd": "http://sweetontology.net/humanKnowledgeDomain/",
    "s4ee": "https://w3id.org/saref4ee#",
    "noise": "http://vocab.linkeddata.es/datosabiertos/def/medio-ambiente/contaminacion-acustica#",
    "pham": "https://w3id.org/skgo/pham#",
    "nas": "https://data.nasa.gov/ontologies/atmonto/NAS#",
    "rami": "http://iais.fraunhofer.de/vocabs/rami#",
    "vocals": "http://w3id.org/rsp/vocals#",
    "rsctx": "http://softeng.polito.it/rsctx#",
    "cska": "http://pfclitex.com/",
    "cog": "http://purl.org/ontology/cco/core#",
    "obws": "http://delicias.dia.fi.upm.es/ontologies/ObjectWithStates.owl#",
    "esdbpr": "http://es.dbpedia.org/resource/",
    "bld": "http://biglinkeddata.com/",
    "ocds": "http://purl.org/onto-ocds/ocds#",
    "dbms": "http://www.openlinksw.com/ontology/dbms-app-ontology#",
    "wdtn": "http://www.wikidata.org/prop/direct-normalized/",
    "powla": "http://purl.org/powla/powla.owl#",
    "s4syst": "https://saref.etsi.org/saref4syst/",
    "mus": "http://data.doremus.org/ontology#",
    "goaf": "http://goaf.fr/goaf#",
    "spvqa": "https://bmake.th-brandenburg.de/spv#",
    "otl": "https://w3id.org/opentrafficlights#",
    "lg": "https://purl.org/lg/",
    "qkdv": "http://qudt.org/vocab/dimensionvector/",
    "ermrk": "http://www.essepuntato.it/2008/12/earmark#",
    "ksam": "http://kulturarvsdata.se/ksamsok#",
    "phy": "https://w3id.org/skgo/phy#",
    "veo": "http://linkeddata.finki.ukim.mk/lod/ontology/veo#",
    "tree": "https://w3id.org/tree#",
    "cbb": "https://data.cbb.omgeving.vlaanderen.be/ns/cbb#",
    "oop": "http://w3id.org/oop#",
    "dby": "http://dbpedia.org/class/yago/",
    "occ": "http://w3id.org/occ#",
    "loci": "http://linked.data.gov.au/def/loci#",
    "gdprov": "https://w3id.org/GDPRov#",
    "m3lite": "http://purl.org/iot/vocab/m3-lite#",
    "crminf": "http://www.cidoc-crm.org/cidoc-crm/CRMinf/",
    "omnlc": "http://open-multinet.info/ontology/omn-lifecycle#",
    "exo": "https://w3id.org/example#",
    "jup": "http://w3id.org/charta77/jup/",
    "gdprtext": "https://w3id.org/GDPRtEXT#",
    "ii": "http://sparql.cwrc.ca/ontologies/ii#",
    "geofabric": "http://linked.data.gov.au/def/geofabric#",
    "imjv": "https://data.imjv.omgeving.vlaanderen.be/ns/imjv#",
    "oup": "http://purl.org/ontology-use-patterns#",
    "manto": "http://com.vortic3.MANTO/",
    "iospress": "http://ld.iospress.nl/rdf/ontology/",
    "xbrll": "https://w3id.org/vocab/xbrll#",
    "dm": "http://datamusee.givingsense.eu/onto/",
    "gmo": "http://purl.jp/bio/10/gmo/",
    "gnaf": "http://linked.data.gov.au/def/gnaf#",
    "losp": "http://sparql.sstu.ru:3030/speciality/",
    "lblodlg": "http://data.lblod.info/vocabularies/leidinggevenden/",
    "eproc": "http://10.0.3.120/download/eproc_FORN_v02.owl#",
    "isoadr": "http://reference.data.gov.au/def/ont/iso19160-1-address#",
    "hosp": "http://health.data.gov/def/hospital/",
    "esagen": "http://vocab.ciudadesabiertas.es/def/sector-publico/agenda-municipal#",
    "daap": "http://daap.dsi.universite-paris-saclay.fr/wiki/",
    "terms": "http://purl.org/dc/terms/",
    "gcon": "https://w3id.org/GConsent#",
    "eproc2": "http://10.0.3.120/download/eproc_FORN_v04.owl#",
    "fel": "http://w3id.org/vcb/fel#",
    "soma": "http://sweetontology.net/matr/",
    "lesa": "http://hadatac.org/ont/lesa#",
    "earth": "http://linked.earth/ontology#",
    "constant": "http://qudt.org/vocab/constant/",
    "dave": "http://theme-e.adaptcentre.ie/dave#",
    "eppl": "https://w3id.org/ep-plan#",
    "bsh": "https://brickschema.org/schema/1.1.0/BrickShape#",
    "bitl": "http://lib.bit.edu.cn/ontology/1.0/",
    "foio": "https://w3id.org/seas/FeatureOfInterestOntology/",
    "wild": "http://purl.org/wild/vocab#",
    "modsci": "https://w3id.org/skgo/modsci#",
    "sorealc": "http://sweetontology.net/realmLandCoastal/",
    "sfl": "http://data.finlex.fi/schema/sfl/",
    "ods": "http://lod.xdams.org/ontologies/ods/",
    "sopropsp": "http://sweetontology.net/propSpeed/",
    "asgs": "http://linked.data.gov.au/def/asgs#",
    "eqp": "https://data.nasa.gov/ontologies/atmonto/equipment#",
    "cwmo": "http://purl.org/cwmo/#",
    "dmp": "http://www.sysresearch.org/rda-common-dmp#",
    "sopropsl": "http://sweetontology.net/propSpaceLocation/",
    "dprov": "http://promsns.org/def/do#",
    "soproptg": "http://sweetontology.net/propTemperatureGradient/",
    "biolink": "https://w3id.org/biolink/vocab/",
    "apb": "http://www.analysispartners.org/businessmodel/",
    "osys": "http://purl.org/olia/system.owl#",
    "sopropr": "http://sweetontology.net/propRotation/",
    "sohues": "http://sweetontology.net/humanEnvirStandards/",
    "iaph": "http://www.juntadeandalucia.es/datosabiertos/portal/iaph/dataset/dataset/6c199ca2-8d2e-4c12-833c-f28",
    "soproptf": "http://sweetontology.net/propTimeFrequency/",
    "cci": "http://cookingbigdata.com/linkeddata/ccinstances#",
    "sohut": "http://sweetontology.net/humanTransportation/",
    "sopropsdis": "http://sweetontology.net/propSpaceDistance/",
    "skoslex": "https://bp4mc2.org/def/skos-lex#",
    "sorelt": "http://sweetontology.net/relaTime/",
    "sopropsh": "http://sweetontology.net/propSpaceHeight/",
    "eupont": "http://elite.polito.it/ontologies/eupont.owl#",
    "epplan": "https://w3id.org/ep-plan#",
    "sopropti": "http://sweetontology.net/propTime/",
    "shema": "http://schema.org/",
    "somaae": "http://sweetontology.net/matrAerosol/",
    "sorelm": "http://sweetontology.net/relaMath/",
    "sorelh": "http://sweetontology.net/relaHuman/",
    "sopropsdir": "http://sweetontology.net/propSpaceDirection/",
    "soreaa": "http://sweetontology.net/realmAtmo/",
    "sophatmowm": "https://sweetontology.net/phenAtmoWindMesoscale/",
    "pplan": "http://purl.org/net/p-plan#",
    "eccf": "http://data.europa.eu/54i/",
    "sostth": "http://sweetontology.net/stateThermodynamic/",
    "sorepmo": "http://sweetontology.net/reprMathOperation/",
    "somaoc": "http://sweetontology.net/matrOrganicCompound/",
    "esgs": "https://w3id.org/edwin/ontology/",
    "extech": "https://w3id.org/executionTechnique/ontology/",
    "chemsci": "https://w3id.org/skgo/chemsci#",
    "sostv": "http://sweetontology.net/stateVisibility/",
    "twitter": "http://stocktwits.com/",
    "sohur": "http://sweetontology.net/humanResearch/",
    "somarock": "http://sweetontology.net/matrRock/",
    "soreaas": "http://sweetontology.net/realmAstroStar/",
    "sosttg": "http://sweetontology.net/stateTimeGeologic/",
    "dbm": "http://purl.org/net/dbm/ontology#",
    "hctl": "https://www.w3.org/2019/wot/hypermedia#",
    "qk": "http://qudt.org/vocab/quantitykind/",
    "sopropi": "http://sweetontology.net/propIndex/",
    "sostso": "http://sweetontology.net/stateSolid/",
    "dentsci": "https://w3id.org/skgo/dentsci#",
    "soreacz": "http://sweetontology.net/realmClimateZone/",
    "yandex": "http://yandex.ru/",
    "stx": "http://purl.org/cyber/stix#",
    "misp": "http://purl.org/cyber/misp#",
    "sorepsc": "http://sweetontology.net/reprSciComponent/",
    "somamin": "http://sweetontology.net/matrMineral/",
    "sostrr": "http://sweetontology.net/stateRoleRepresentative/",
    "stencila": "http://schema.stenci.la/",
    "edupro": "http://ns.inria.fr/semed/eduprogression#",
    "rico": "https://www.ica.org/standards/RiC/ontology#",
    "donto": "http://reference.data.gov.au/def/ont/dataset#",
    "sopropp": "http://sweetontology.net/propPressure/",
    "soprops": "http://sweetontology.net/propSpace/",
    "sopropsm": "http://sweetontology.net/propSpaceMultidimensional/",
    "pineapple": "http://hexananas.com/pineapple#",
    "sopropo": "http://sweetontology.net/propOrdinal/",
    "sostri": "http://sweetontology.net/stateRoleImpact/",
    "soreao": "http://sweetontology.net/realmOcean/",
    "istex": "https://data.istex.fr/ontology/istex#",
    "sorelsp": "http://sweetontology.net/relaSpace/",
    "sohuj": "http://sweetontology.net/humanJurisdiction/",
    "sopropmf": "http://sweetontology.net/propMassFlux/",
    "probont": "http://www.probonto.org/ontology#",
    "sohutr": "http://sweetontology.net/humanTechReadiness/",
    "sorepdp": "http://sweetontology.net/reprDataProduct/",
    "sohuecons": "http://sweetontology.net/humanEnvirConservation/",
    "sostst": "http://sweetontology.net/stateStorm/",
    "sopropq": "http://sweetontology.net/propQuantity/",
    "sorel": "http://sweetontology.net/rela/",
    "sostrt": "http://sweetontology.net/stateRoleTrust/",
    "sopropt": "http://sweetontology.net/propTemperature/",
    "mccv": "http://purl.jp/bio/10/mccv#",
    "somaem": "http://sweetontology.net/matrElementalMolecule/",
    "esagm": "http://vocab.ciudadesabiertas.es/def/sector-publico/agenda-municipal#",
    "atts": "https://data.nasa.gov/ontologies/atmonto/general#",
    "inchikey": "https://identifiers.org/inchikey:",
    "sosttf": "http://sweetontology.net/stateTimeFrequency/",
    "sosttc": "http://sweetontology.net/stateTimeCycle/",
    "sorepsl": "http://sweetontology.net/reprSciLaw/",
    "somael": "http://sweetontology.net/matrElement/",
    "wotsec": "https://www.w3.org/2019/wot/security#",
    "sorepscd": "http://sweetontology.net/reprSpaceCoordinate/",
    "pq": "http://www.wikidata.org/prop/qualifier/",
    "sost": "http://sweetontology.net/state/",
    "sorealp": "http://sweetontology.net/realmLandProtected/",
    "soreahb": "http://sweetontology.net/realmHydroBody/",
    "sopropst": "http://sweetontology.net/propSpaceThickness/",
    "soreac": "http://sweetontology.net/realmCryo/",
    "sophst": "http://sweetontology.net/phenStar/",
    "sophcr": "http://sweetontology.net/phenCryo/",
    "sostsy": "http://sweetontology.net/stateSystem/",
    "sorear": "http://sweetontology.net/realmRegion/",
    "somaind": "http://sweetontology.net/matrIndustrial/",
    "somapl": "http://sweetontology.net/matrPlant/",
    "capes": "http://vocab.capes.gov.br/def/vcav#",
    "sorepdm": "http://sweetontology.net/reprDataModel/",
    "somaen": "http://sweetontology.net/matrEnergy/",
    "somab": "http://sweetontology.net/matrBiomass/",
    "sophatmopc": "http://sweetontology.net/phenAtmoPrecipitation/",
    "proton": "http://www.ontotext.com/proton/",
    "soreas": "http://sweetontology.net/realmSoil/",
    "cfrl": "http://linkeddata.finki.ukim.mk/lod/ontology/cfrl#",
    "sorelpr": "http://sweetontology.net/relaProvenance/",
    "sophsy": "http://sweetontology.net/phenSystem/",
    "soprocsc": "http://sweetontology.net/procStateChange/",
    "sorepdsg": "http://sweetontology.net/reprDataServiceGeospatial/",
    "sopropfr": "http://sweetontology.net/propFraction/",
    "sorepmso": "http://sweetontology.net/reprMathSolution/",
    "sorept": "http://sweetontology.net/reprTime/",
    "soreabb": "http://sweetontology.net/realmBiolBiome/",
    "soproc": "http://sweetontology.net/proc/",
    "sorelph": "http://sweetontology.net/relaPhysical/",
    "sopropb": "http://sweetontology.net/propBinary/",
    "somanr": "http://sweetontology.net/matrNaturalResource/",
    "sopropcap": "http://sweetontology.net/propCapacity/",
    "sorep": "http://sweetontology.net/repr/",
    "soreaofe": "http://sweetontology.net/realmOceanFeature/",
    "sopropcha": "http://sweetontology.net/propCharge/",
    "sophec": "http://sweetontology.net/phenEcology/",
    "atd": "https://data.nasa.gov/ontologies/atmonto/data#",
    "soman": "http://sweetontology.net/matrAnimal/",
    "sopropdifu": "http://sweetontology.net/propDiffusivity/",
    "soprocp": "http://sweetontology.net/procPhysical/",
    "sorelcl": "http://sweetontology.net/relaClimate/",
    "jsonschema": "https://www.w3.org/2019/wot/json-schema#",
    "sorepmg": "http://sweetontology.net/reprMathGraph/",
    "soprocc": "http://sweetontology.net/procChemical/",
    "sorelch": "http://sweetontology.net/relaChemical/",
    "sorepmst": "http://sweetontology.net/reprMathStatistics/",
    "sophso": "http://sweetontology.net/phenSolid/",
    "sostti": "http://sweetontology.net/stateTime/",
    "somais": "http://sweetontology.net/matrIsotope/",
    "sorepsrs": "http://sweetontology.net/reprSpaceReferenceSystem/",
    "soprope": "http://sweetontology.net/propEnergy/",
    "somas": "http://sweetontology.net/matrSediment/",
    "sohueccont": "http://sweetontology.net/humanEnvirControl/",
    "somains": "http://sweetontology.net/matrInstrument/",
    "soreaaw": "http://sweetontology.net/realmAtmoWeather/",
    "sorelsc": "http://sweetontology.net/relaSci/",
    "somac": "http://sweetontology.net/matrCompound/",
    "sorepdsv": "http://sweetontology.net/reprDataServiceValidation/",
    "somaf": "http://sweetontology.net/matrFacility/",
    "d2s": "https://w3id.org/d2s/",
    "sorepsd": "http://sweetontology.net/reprSpaceDirection/",
    "sostc": "http://sweetontology.net/stateChemical/",
    "sopropcon": "http://sweetontology.net/propConductivity/",
    "sophatmofr": "http://sweetontology.net/phenAtmoFront/",
    "sopropdr": "http://sweetontology.net/propDimensionlessRatio/",
    "sorepdsa": "http://sweetontology.net/reprDataServiceAnalysis/",
    "sorepmfo": "http://sweetontology.net/reprMathFunctionOrthogonal/",
    "sophod": "http://sweetontology.net/phenOceanDynamics/",
    "sopropm": "http://sweetontology.net/propMass/",
    "sorepts": "http://sweetontology.net/reprTimeSeason/",
    "sorepsme": "http://sweetontology.net/reprSciMethodology/",
    "soreaabl": "http://sweetontology.net/realmAtmoBoundaryLayer/",
    "sophatmofo": "http://sweetontology.net/phenAtmoFog/",
    "soph": "http://sweetontology.net/phen/",
    "sorepsu": "http://sweetontology.net/reprSciUnits/",
    "soreps": "http://sweetontology.net/reprSpace/",
    "sophel": "http://sweetontology.net/phenElecMag/",
    "phto": "http://rhizomik.net/ontologies/PlantHealthThreats.owl.ttl#",
    "soreaofl": "http://sweetontology.net/realmOceanFloor/",
    "sorepsf": "http://sweetontology.net/reprSciFunction/",
    "sophm": "http://sweetontology.net/phenMixing/",
    "sohua": "http://sweetontology.net/humanAgriculture/",
    "sophatmow": "http://sweetontology.net/phenAtmoWind/",
    "soreal": "http://sweetontology.net/realmLandform/",
    "sorepdf": "http://sweetontology.net/reprDataFormat/",
    "sophpc": "http://sweetontology.net/phenPlanetClimate/",
    "sorepm": "http://sweetontology.net/reprMath/",
    "sophatmoc": "http://sweetontology.net/phenAtmoCloud/",
    "sopropcou": "http://sweetontology.net/propCount/",
    "sopropche": "http://sweetontology.net/propChemical/",
    "soprop": "http://sweetontology.net/prop/",
    "sosto": "http://sweetontology.net/stateOrdinal/",
    "sopropcat": "http://sweetontology.net/propCategorical/",
    "sweet": "http://sweetontology.net/",
    "sophoc": "http://sweetontology.net/phenOceanCoastal/",
    "sorepdsr": "http://sweetontology.net/reprDataServiceReduction/",
    "somaio": "http://sweetontology.net/matrIon/",
    "sorepmf": "http://sweetontology.net/reprMathFunction/",
    "ci": "https://privatealpha.com/ontology/content-inventory/1#",
    "sophhy": "http://sweetontology.net/phenHydro/",
    "cbs": "http://betalinkeddata.cbs.nl/def/cbs#",
    "sophr": "http://sweetontology.net/phenReaction/",
    "sophwn": "http://sweetontology.net/phenWaveNoise/",
    "sophb": "http://sweetontology.net/phenBiol/",
    "sophen": "http://sweetontology.net/phenEnergy/",
    "somaw": "http://sweetontology.net/matrWater/",
    "sophei": "http://sweetontology.net/phenEnvirImpact/",
    "sopropef": "http://sweetontology.net/propEnergyFlux/",
    "sophfi": "http://sweetontology.net/phenFluidInstability/",
    "sophft": "http://sweetontology.net/phenFluidTransport/",
    "ei2a": "http://opendata.aragon.es/def/ei2a#",
    "sorepds": "http://sweetontology.net/reprDataService/",
    "sostb": "http://sweetontology.net/stateBiological/",
    "sopropfu": "http://sweetontology.net/propFunction/",
    "soreptd": "http://sweetontology.net/reprTimeDay/",
    "sophatmot": "http://sweetontology.net/phenAtmoTransport/",
    "somaeq": "http://sweetontology.net/matrEquipment/",
    "sopropdife": "http://sweetontology.net/propDifference/",
    "somarocki": "http://sweetontology.net/matrRockIgneous/",
    "sorealo": "http://sweetontology.net/realmLandOrographic/",
    "sophatmos": "http://sweetontology.net/phenAtmoSky/",
    "sopho": "http://sweetontology.net/phenOcean/",
    "sorepsg3": "http://sweetontology.net/reprSpaceGeometry3D/",
    "sophw": "http://sweetontology.net/phenWave/",
    "sophhe": "http://sweetontology.net/phenHelio/",
    "sophsyc": "http://sweetontology.net/phenSystemComplexity/",
    "ordo": "http://www.orpha.net/ORDO/",
    "ccsla": "http://cookingbigdata.com/linkeddata/ccsla#",
    "sophatmo": "http://sweetontology.net/phenAtmo/",
    "sophcy": "http://sweetontology.net/phenCycle/",
    "ciao": "http://ciao.it/",
    "sophfd": "http://sweetontology.net/phenFluidDynamics/",
    "ccp": "http://cookingbigdata.com/linkeddata/ccpricing#",
    "snomedct": "http://purl.bioontology.org/ontology/SNOMEDCT/",
    "soreaah": "http://sweetontology.net/realmAstroHelio/",
    "sostdp": "http://sweetontology.net/stateDataProcessing/",
    "sostrg": "http://sweetontology.net/stateRoleGeographic/",
    "sorepsp": "http://sweetontology.net/reprSciProvenance/",
    "trek": "https://w3id.org/trek/",
    "sostro": "http://sweetontology.net/stateRole/",
    "somapa": "http://sweetontology.net/matrParticle/",
    "sophatmops": "http://sweetontology.net/phenAtmoPressure/",
    "ingredient": "http://www.owl-ontologies.com/test.owl/ingredient/",
    "sophatmol": "http://sweetontology.net/phenAtmoLightning/",
    "ldc": "https://tac.nist.gov/tracks/SM-KBP/2018/ontologies/SeedlingOntology#",
    "skosthes": "http://purl.org/iso25964/skos-thes#",
    "sostre": "http://sweetontology.net/stateRealm/",
    "soprocw": "http://sweetontology.net/procWave/",
    "atm": "https://data.nasa.gov/ontologies/atmonto/ATM#",
    "sophcm": "http://sweetontology.net/phenCycleMaterial/",
    "sostf": "http://sweetontology.net/stateFluid/",
    "sohu": "http://sweetontology.net/human/",
    "somamic": "http://sweetontology.net/matrMicrobiota/",
    "sostef": "http://sweetontology.net/stateEnergyFlux/",
    "mmms": "http://ldf.fi/schema/mmm/",
    "sostp": "http://sweetontology.net/statePhysical/",
    "beo": "http://pi.pauwel.be/voc/buildingelement#",
    "sorealv": "http://sweetontology.net/realmLandVolcanic/",
    "sostrc": "http://sweetontology.net/stateRoleChemical/",
    "pnv": "https://w3id.org/pnv#",
    "bldont": "http://ont.biglinkeddata.com/",
    "sostrb": "http://sweetontology.net/stateRoleBiological/",
    "sorepsmo": "http://sweetontology.net/reprSciModel/",
    "bperson": "http://data.vlaanderen.be/ns/persoon#",
    "sorealf": "http://sweetontology.net/realmLandFluvial/",
    "ocsw": "http://data.diekb.org/def/ocsw#",
    "mbkeys": "https://pastebin.com/ThBfphb8#",
    "esbici": "http://vocab.ciudadesabiertas.es/def/transporte/bicicleta-publica#",
    "matvoc": "http://stream-ontology.com/matvoc/",
    "lprov": "http://id.learning-provider.data.ac.uk/terms#",
    "idsc": "https://w3id.org/idsa/code/",
    "ccr": "http://cookingbigdata.com/linkeddata/ccregions#",
    "sostsb": "http://sweetontology.net/stateSpectralBand/",
    "schoi": "https://w3id.org/scholarlydata/ontology/indicators-ontology.owl#",
    "soreaer": "http://sweetontology.net/realmEarthReference/",
    "sohuea": "http://sweetontology.net/humanEnvirAssessment/",
    "wds": "http://www.wikidata.org/entity/statement/",
    "sostss": "http://sweetontology.net/stateSpaceScale/",
    "gleio": "http://lei.info/gleio/",
    "soall": "http://sweetontology.net/sweetAll/",
    "sorealg": "http://sweetontology.net/realmLandGlacial/",
    "ccomid": "http://www.ontologyrepository.com/CommonCoreOntologies/Mid/",
    "omop": "http://api.ohdsi.org/WebAPI/vocabulary/concept/",
    "sohud": "http://sweetontology.net/humanDecision/",
    "lv2": "http://lv2plug.in/ns/lv2core/",
    "malaka": "http://george.gr/",
    "hdgi": "https://w3id.org/hdgi#",
    "sorealt": "http://sweetontology.net/realmLandTectonic/",
    "sophg": "http://sweetontology.net/phenGeol/",
    "sophgt": "http://sweetontology.net/phenGeolTectonic/",
    "she": "http://shacleditor.org/",
    "biogrid": "http://thebiogrid.org/",
    "soreaab": "http://sweetontology.net/realmAstroBody/",
    "sostsp": "http://sweetontology.net/stateSpace/",
    "ggbn": "http://data.ggbn.org/schemas/ggbn/terms/",
    "sostsl": "http://sweetontology.net/stateSpectralLine/",
    "soreala": "http://sweetontology.net/realmLandAeolian/",
    "arp": "http://www.arpenteur.org/ontology/Arpenteur.owl#",
    "sostsc": "http://sweetontology.net/stateSpaceConfiguration/",
    "taxref": "http://taxref.mnhn.fr/lod/taxon/",
    "osmm": "https://www.openstreetmap.org/meta/",
    "sophgf": "http://sweetontology.net/phenGeolFault/",
    "sophgg": "http://sweetontology.net/phenGeolGeomorphology/",
    "rdb": "http://www.dbs.cs.uni-duesseldorf.de/RDF/relational#",
    "sohuc": "http://sweetontology.net/humanCommerce/",
    "compub": "https://sireneld.io/vocab/compub#",
    "sophgv": "http://sweetontology.net/phenGeolVolcano/",
    "dfcb": "http://datafoodconsortium.org/ontologies/DFC_BusinessOntology.owl#",
    "sophgs": "http://sweetontology.net/phenGeolSeismicity/",
    "omim": "http://purl.bioontology.org/ontology/OMIM/",
    "docam": "https://www.docam.ca/glossaurus/",
    "birthdate": "http://schema.org/birthDate/",
    "country": "http://eulersharp.sourceforge.net/2003/03swap/countries#",
    "s4city": "https://saref.etsi.org/saref4city/",
    "rank": "http://www.ontotext.com/owlim/RDFRank#",
    "oplsoft": "http://www.openlinksw.com/ontology/software#",
    "dfc": "http://datafoodconsortium.org/ontologies/DFC_FullModel.owl#",
    "sorea": "http://sweetontology.net/realm/",
    "mpg123": "https://devuan.net.br/wiki/mpg123/",
    "gx": "https://graphite.synaptica.net/extension/",
    "mobiliteit": "https://data.vlaanderen.be/ns/mobiliteit#",
    "brot": "https://w3id.org/brot#",
    "osmt": "https://wiki.openstreetmap.org/wiki/Key:",
    "wasa": "http://vocab.sti2.at/wasa/",
    "fernanda": "http://fernanda.nl/",
    "asio": "http://purl.org/hercules/asio/core#",
    "uimo": "http://vocab.sti2.at/uimo/",
    "io": "https://iaco.me/",
    "dd": "http://example.org/dummydata/",
    "ld": "http://linkeddata.ru/",
    "s4ener": "https://saref.etsi.org/saref4ener/",
    "wotc": "http://purl.org/wot-catalogue#",
    "mgv": "http://mangaview.fr/mgv#",
    "saref4envi": "https://saref.etsi.org/saref4envi/",
    "osmrel": "https://www.openstreetmap.org/relation/",
    "say": "http://example.org/say/",
    "iaco": "https://iaco.me/",
    "gas": "http://www.bigdata.com/rdf/gas#",
    "s4agri": "https://saref.etsi.org/saref4agri/",
    "osmway": "https://www.openstreetmap.org/way/",
    "taxrefprop": "http://taxref.mnhn.fr/lod/property/",
    "osmnode": "https://www.openstreetmap.org/node/",
    "bs": "https://w3id.org/def/basicsemantics-owl#",
    "knows": "http://semantic.komc/usu/2020/knows#",
    "lexicog": "http://www.w3.org/ns/lemon/lexicog#",
    "movieo": "http://movie.com/ontology/",
    "oplfeat": "http://www.openlinksw.com/ontology/features#",
    "univ": "http://univ.io/",
    "dbonto": "http://dbepedia.org/ontology/",
    "trak": "https://trakmetamodel.sourceforge.io/vocab/rdf-schema.rdf#",
    "cts": "http://rdf.cdisc.org/ct/schema#",
    "bao": "http://www.bioassayontology.org/bao#",
    "persoon": "http://data.vlaanderen.be/ns/persoon#",
    "oco": "https://w3id.org/oc/ontology/",
    "gco": "http://purl.jp/bio/12/glyco/conjugate#",
    "lib": "http://purl.org/library/",
    "srv": "http://www.daml.org/services/owl-s/1.2/Service.owl#",
    "ogura": "https://sparql.crssnky.xyz/Ogura_Hyakunin_Isshu_LinkedRDF/URIs/Ogura_Hyakunin_Isshu_schema.ttl#",
    "pgxo": "http://pgxo.loria.fr/",
    "jur": "http://sweet.jpl.nasa.gov/2.3/humanJurisdiction.owl#",
    "hola": "https://moodle.insa-lyon.fr/course/view.php?id=",
    "waa": "http://purl.oclc.org/NET/WebApiAuthentication#",
    "esconv": "http://vocab.ciudadesabiertas.es/def/sector-publico/convenio#",
    "kko": "http://kbpedia.org/kko/rc/",
    "toaru": "https://metadata.moe/toaru-sparql/elements/",
    "rl": "http://rl.com/resources/",
    "cso": "http://cso.kmi.open.ac.uk/schema/cso/",
    "motogp": "http://www.motogp.com/",
    "mltd": "https://mltd.pikopikopla.net/mltd-schema#",
    "fibo": "https://spec.edmcouncil.org/fibo/ontology/master/latest/",
    "vlueprint": "https://vlueprint.org/schema/",
    "mr": "http://marineregions.org/ns/ontology#",
    "ams": "http://data.amadeus.com/",
    "karstlink": "https://ontology.uis-speleo.org/ontology/#",
    "maroc": "http://fr.dbpedia.org/page/Maroc/",
    "prismdb": "https://prismdb.takanakahiko.me/prism-schema.ttl#",
    "ebg": "http://data.businessgraph.io/ontology#",
    "estraf": "http://vocab.ciudadesabiertas.es/def/transporte/trafico#",
    "melding": "http://lblod.data.gift/vocabularies/automatische-melding/",
    "eppo": "https://gd.eppo.int/taxon/",
    "esautob": "http://vocab.ciudadesabiertas.es/def/transporte/autobus#",
    "ibeacon": "http://vocab.rapidthings.eu/ns/apple/ibeacon.ttl#",
    "marcgt": "https://id.loc.gov/vocabulary/marcgt/",
    "accid": "http://pid.accurids.com/",
    "ssnx": "http://purl.oclc.org/NET/ssnx/ssn#",
    "ble": "http://vocab.rapidthings.eu/ns/ble.ttl#",
    "nsg": "https://neuroshapes.org/",
    "xyz": "http://sparql.xyz/facade-x/data/",
    "fx": "http://sparql.xyz/facade-x/ns/",
    "la": "https://linked.art/ns/terms/",
    "quran": "http://khalidaloufi.sa/quran#",
    "contry": "http://dbpedia.org/resource/Lyon#",
    "sty": "http://purl.bioontology.org/ontology/STY/",
    "contax": "https://w3id.org/con-tax#",
    "esempleo": "http://vocab.ciudadesabiertas.es/def/sector-publico/empleo#",
    "mnx": "https://rdf.metanetx.org/schema/",
    "i18n": "https://www.w3.org/ns/i18n#",
    "tso": "https://w3id.org/tso#",
    "rdaep": "http://rdaregistry.info/termList/RDAExtensionPlan/",
    "rdat": "http://rdaregistry.info/Elements/t/",
    "mdcs": "https://mdcs.monumentenkennis.nl/damageatlas/ontology#",
    "rdapol": "http://rdaregistry.info/termList/RDAPolarity/",
    "rdaut": "http://rdaregistry.info/termList/RDAUnitOfTime/",
    "w3geo": "http://www.w3.org/2003/01/geo/wgs84_pos#",
    "oeso": "http://www.opensilex.org/vocabularies/oeso#",
    "gom": "https://w3id.org/gom#",
    "rofchrda": "http://rdaregistry.info/termList/rofchrda/",
    "ldes": "http://w3id.org/ldes#",
    "cto": "https://w3id.org/cto#",
    "w3id": "https://w3id.org/",
    "bdg": "http://data.bigdatagrapes.eu/resource/ontology/",
    "rdaio": "http://rdaregistry.info/Elements/i/object/",
    "rdan": "http://rdaregistry.info/Elements/n/",
    "bleadapter": "http://vocab.rapidthings.eu/ns/ble/adapter.ttl#",
    "bop": "https://w3id.org/bop#",
    "datagc": "https://data.grottocenter.org/ldp/",
    "kdsf": "https://kerndatensatz-forschung.de/version1/technisches_datenmodell/owl/kdsf.owl#",
    "rdamo": "http://rdaregistry.info/Elements/m/object/",
    "rdasource": "http://rdaregistry.info/termList/RDARecordingSources/",
    "lado": "http://archaeology.link/ontology#",
    "vph": "http://purl.org/ozo/vph.owl#",
    "check": "http://pornhub.com/",
    "rdatd": "http://rdaregistry.info/Elements/t/datatype/",
    "dom": "https://html.spec.whatwg.org/#",
    "rdapath": "http://rdaregistry.info/termList/RDARecordingMethods/",
    "hops": "https://rdf.ag/o/hops#",
    "samian": "http://lod.archaeology.link/data/samian/",
    "geodcat": "http://data.europa.eu/930/",
    "textgrid": "https://textgridrep.org/",
    "vr": "https://www.w3.org/2018/credentials/v1/",
    "itops": "https://vocab.eccenca.com/itops/",
    "mesh2021": "http://id.nlm.nih.gov/mesh/2021/",
    "rdaxd": "http://rdaregistry.info/Elements/x/datatype/",
    "rdatb": "http://rdaregistry.info/termList/RDATypeOfBinding/",
    "rdamd": "http://rdaregistry.info/Elements/m/datatype/",
    "rdaao": "http://rdaregistry.info/Elements/a/object/",
    "rdand": "http://rdaregistry.info/Elements/n/datatype/",
    "smithy": "https://awslabs.github.io/smithy/rdf-1.0#",
    "rdawd": "http://rdaregistry.info/Elements/w/datatype/",
    "rdap": "http://rdaregistry.info/Elements/p/",
    "rdaeo": "http://rdaregistry.info/Elements/e/object/",
    "rdano": "http://rdaregistry.info/Elements/n/object/",
    "matrycs": "http://matrycs.com/",
    "cerealstoo": "http://rdf.ag/o/cerealstoo#",
    "rpg": "http://rpg.data.is4.site/",
    "rdapd": "http://rdaregistry.info/Elements/p/datatype/",
    "rdato": "http://rdaregistry.info/Elements/t/object/",
    "rdaxo": "http://rdaregistry.info/Elements/x/object/",
    "rdaed": "http://rdaregistry.info/Elements/e/datatype/",
    "rdatask": "http://rdaregistry.info/termList/RDATasks/",
    "sou": "http://qudt.org/vocab/sou/",
    "freq": "http://purl.org/cld/freq/",
    "rdamat": "http://rdaregistry.info/termList/RDAMaterial/",
    "epcis": "https://ns.gs1.org/epcis/",
    "signify": "http://purl.org/signify/ns#",
    "rdasca": "http://rdaregistry.info/termList/scale/",
    "ogham": "http://lod.ogham.link/data/",
    "rdawo": "http://rdaregistry.info/Elements/w/object/",
    "rdaid": "http://rdaregistry.info/Elements/i/datatype/",
    "srr": "https://w3id.org/srr#",
    "rofitrda": "http://rdaregistry.info/termList/rofitrda/",
    "slm": "http://urn.fi/URN:NBN:fi:au:slm:",
    "rdaim": "http://rdaregistry.info/termList/RDAInteractivityMode/",
    "roffgrda": "http://rdaregistry.info/termList/roffgrda/",
    "cbv": "https://ns.gs1.org/cbv/",
    "oghamonto": "http://ontology.ogham.link/",
    "kpd": "http://purl.org/kpd/",
    "citedcat": "https://w3id.org/citedcat-ap/",
    "rofsfrda": "http://rdaregistry.info/termList/rofsfrda/",
    "bag2": "http://bag.basisregistraties.overheid.nl/def/bag#",
    "m8g": "http://data.europa.eu/m8g/",
    "cinema": "http://www.semanticweb.org/julien/morgann/cinema#",
    "seasd": "https://w3id.org/seas/",
    "faas": "http://semantic-faas.com/ontology#",
    "ofn": "http://www.ontotext.com/sparql/functions/",
    "nprl": "http://data.nobelprize.org/resource/laureate/",
    "uberon": "http://purl.obolibrary.org/obo/UBERON_",
    "cpg": "http://modellingdh.github.io/ont/odp/pgc/",
    "encargado": "http://semRAT.edu/",
    "idpo": "https://w3id.org/idpo#",
    "luigiusai": "https://www.luigiusai.it/wp#",
    "bcfowl": "http://lbd.arch.rwth-aachen.de/bcfOWL#",
    "bcom": "https://w3id.org/bcom#",
    "folio": "http://IBCNServices.github.io/Folio-Ontology/Folio.owl#",
    "memorix": "http://memorix.io/ontology#",
    "mag": "https://makg.org/property/",
    "arena": "https://solid.ti.rw.fau.de/public/ns/arena#",
    "tci": "https://w3id.org/lbs/tci#",
    "mrk": "http://www.mydomain.org/Mrk-ns#",
    "paf": "https://paf.link/",
    "gax": "http://w3id.org/gaia-x/core#",
    "nanopub": "http://www.nanopub.org/nschema#",
    "lsqr": "http://lsq.aksw.org/",
    "ewg": "http://ethoinformatics.org/",
    "s223": "http://data.ashrae.org/standard223#",
    "ch": "https://schema.ld.admin.ch/",
    "ghga": "http://w3id.org/ghga/",
    "nsd": "https://w3id.org/nsd#",
    "mrt": "http://marineregions.org/ns/placetypes#",
    "ppeer": "http://parliament.uk/ontologies/peerage/",
    "comp": "http://semweb.mmlab.be/ns/rml-compression#",
    "srmo": "https://w3id.org/srmo#",
    "interop": "http://www.w3.org/ns/solid/interop#",
    "aspect": "http://purl.org/aspect/",
    "hqdmontol": "http://www.semanticweb.org/magma-core/ontologies/hqdm#",
    "setl": "http://purl.org/twc/vocab/setl/",
    "poke": "https://pokemonkg.org/ontology#",
    "ldpsc": "https://solid.ti.rw.fau.de/public/ns/stream-containers#",
    "rmlt": "http://semweb.mmlab.be/ns/rml-target#",
    "wdno": "http://www.wikidata.org/prop/novalue/",
    "ea": "http://eaontology.protect.linkeddata.es/def/",
    "hqdm": "http://www.semanticweb.org/hqdm#",
    "magmauser": "http://www.semanticweb.org/magma-core/user#",
    "lds": "https://solid.ti.rw.fau.de/public/ns/linked-data-structures#",
    "magmardl": "http://www.semanticweb.org/magma-core/rdl#",
    "biocrm": "http://ldf.fi/schema/bioc/",
    "srtun": "https://www.inf.bi.rub.de/srtun#",
    "djo": "http://purl.org/datajourneys/",
    "esc": "https://solid.ti.rw.fau.de/public/ns/event-sourcing-containers#",
    "cpc": "https://data.epo.org/linked-data/def/cpc/",
    "lrcommon": "http://landregistry.data.gov.uk/def/common/",
    "rc": "https://w3id.org/rc#",
    "srt": "http://w3id.org/srt#",
    "jsonld": "http://www.w3.org/ns/json-ld#",
    "hpont": "https://w3id.org/hpont#",
    "edu": "https://schema.edu.ee/",
    "feed": "https://www.feedipedia.org/",
    "eb": "https://w3id.org/eb#",
    "spec": "https://www.w3.org/ns/spec#",
    "kgi": "http://ns.inria.fr/kg/index#",
    "generiek": "https://data.vlaanderen.be/ns/generiek#",
    "value": "http://gfgfd.vs/",
    "rto": "https://w3id.org/rail/topo#",
    "cgo": "https://www.tno.nl/agrifood/ontology/common-greenhouse-ontology#",
    "react": "https://w3id.org/react#",
    "rro": "http://semanticweb.org/patricia/ontologies/rro#",
    "godaddy": "https://sso.godaddy.com/",
    "bau": "https://terminology.fraunhofer.de/voc/bau#",
    "aff": "https://w3id.org/affectedBy#",
    "eep": "https://w3id.org/eep#",
    "archivo": "https://archivo.dbpedia.org/onto#",
    "gufo": "http://purl.org/nemo/gufo#",
    "wfont": "https://w3id.org/wfont#",
    "ontobras": "http://www.semanticweb.org/fefar/ontologies/ontobras#",
    "raum": "https://terminology.fraunhofer.de/voc/raum#",
    "paam": "https://lod.mediathek-tanz-theater.de/schema/paam/",
    "stix": "http://purl.org/cyber/stix#",
    "olias": "http://purl.org/olia/system.owl#",
    "m4i": "https://www.metadata4ing.org/",
    "bdsubj": "https://purl.org/fidbaudigital/subjects#",
    "caso": "http://www.w3id.org/def/caso#",
    "weki": "https://en.wikipedia.org/wiki/",
    "quid": "https://w3id.org/quid/",
    "respond": "https://w3id.org/respond#",
    "conllu": "https://universaldependencies.org/format.html#",
    "eurio": "http://data.europa.eu/s66#",
    "walmart": "https://www.amazon.de/",
    "opltw": "http://www.openlinksw.com/schemas/twitter#",
    "oidc": "http://www.w3.org/ns/solid/oidc#"
}
export default PREFIX_REFERENCE;